// NOTE: Adding new icons
//   - add (or override) stroke and fill with `currentColor`
//   - correct html attributes like `strokeWidth` to React props like `strokeWidth`
//   - set the `viewBox`, othewise the resizing will break

import sortingContainer from "../../../public/environment-label-icons/sorting-container.png";
import sortingGlass from "../../../public/environment-label-icons/sorting-glass.png";

const iconList = {
  clear: (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20">
      <path
        d="M19.1 4v12a1 1 0 0 1-1 1H5.66a1 1 0 0 1-.86-.5l-3.43-6a1 1 0 0 1 0-1l3.43-6a1 1 0 0 1 .86-.5H18.1a1 1 0 0 1 1 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="m8.25 6.16 7.68 7.68m0-7.68-7.68 7.68" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  lens: (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M13.6 12.6 18 17m-2.8-8.4A5.6 5.6 0 1 1 4 8.6a5.6 5.6 0 0 1 11.2 0Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  copy: (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" d="M3 6h9v11H3z" />
      <path d="M7 5.85V3h9v12h-3.7" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  trash: (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path
        d="m4.906 4.802.8 8.8h6.4l.8-8.8m-8 0h-1.6m1.6 0h1.6m6.4 0h1.6m-1.6 0h-1.6m-4.8 0v-2.4h4.8v2.4m-4.8 0h4.8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "search-arrow": (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path
        d="M4.844 12.239V4.79m0 0h7.448m-7.448 0 8.125 8.126"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  recent: (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <circle cx="8.906" cy="8.002" r="6.4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M8.905 4.402v3.6l3.2 3.2" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  lamp: (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path
        d="M10.799 12.085H7.045c0-1.52-3.058-2.37-3.058-5.765 0-2.587 2.399-4.92 4.92-4.92 2.52 0 4.92 2.002 4.92 4.92 0 3.386-3.028 4.247-3.028 5.765ZM11.188 14.6H6.625M8.905 12.53V8.047M10.332 14.6H7.48M10.652 8.047H7.16"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  hourglass: (
    <svg width="30" height="41" viewBox="0 0 30 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.00104 0.939575L0.0010376 1.93958V7.01651L1.00104 8.01651H3.05384C3.33773 10.9034 4.77483 13.2746 6.71195 15.3316C8.5556 17.2894 10.9141 19.0256 13.2694 20.6955C10.9058 22.3826 8.54297 24.1685 6.69421 26.2164C4.75885 28.3603 3.33858 30.843 3.05219 33.8634H1.00104L0.0010376 34.8634V39.9403L1.00104 40.9403H29L30 39.9403V34.8634L29 33.8634H26.9487C26.6623 30.843 25.242 28.3603 23.3067 26.2164C21.4579 24.1685 19.0951 22.3826 16.7315 20.6955C19.0868 19.0256 21.4453 17.2894 23.2889 15.3316C25.2261 13.2746 26.6632 10.9034 26.9471 8.01651H29L30 7.01651V1.93958L29 0.939575H1.00104ZM15.0004 21.9189C12.4429 23.7316 10.0165 25.5208 8.17878 27.5566C6.48605 29.4317 5.33893 31.4665 5.06328 33.8634H24.9376C24.662 31.4665 23.5148 29.4317 21.8221 27.5566C19.9844 25.5208 17.558 23.7316 15.0004 21.9189ZM15.0004 19.47C17.5647 17.6587 19.992 15.9154 21.8329 13.9605C23.5287 12.1598 24.6623 10.2456 24.9348 8.01651H5.0661C5.33857 10.2456 6.47218 12.1598 8.16796 13.9605C10.0089 15.9154 12.4362 17.6587 15.0004 19.47ZM2.00104 6.01651V2.93958H28V6.01651H2.00104ZM2.00104 38.9403V35.8634H28V38.9403H2.00104Z"
        fill="currentColor"
      />
    </svg>
  ),
  drag: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M7.75 4.5 2.25 10l5.5 5.5M12.25 4.5l5.5 5.5-5.5 5.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "promo-big": (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <path d="m25 36 15-16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="26" cy="22" r="3" stroke="currentColor" strokeWidth="2" />
      <circle cx="39" cy="34" r="3" stroke="currentColor" strokeWidth="2" />
      <path
        d="M48 14v28a1 1 0 0 1-1 1H17.566a1 1 0 0 1-.857-.485l-8.402-14a1 1 0 0 1 0-1.03l8.402-14a1 1 0 0 1 .857-.485H47a1 1 0 0 1 1 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  "click&collect": (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20">
      <path
        d="M7.807 6.39c0-2.061 1.293-3.39 2.889-3.39 1.595 0 2.889 1.329 2.889 3.389m2.167 7.081-4.087-1.828 1.843 4.445m2.244-2.617 2.166.97-2.438 1.06-1.064 2.5-.908-1.913m2.244-2.617c.242-2.442.434-4.181.722-7.081H4.918l.963 9.698h7.627"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  promo: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M5 15 15 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="6" cy="6" r="2" stroke="currentColor" strokeWidth="2" />
      <circle cx="14" cy="14" r="2" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  percentage: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.5 11.9998L12.5 3.99976"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="5.3" cy="4.79971" rx="1.6" ry="1.6" stroke="currentColor" strokeWidth="2" />
      <ellipse cx="11.7" cy="11.1997" rx="1.6" ry="1.6" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  "alert-red": (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2ZM1.4 8a6.6 6.6 0 1 1 13.2 0A6.6 6.6 0 0 1 1.4 8ZM8 9.4a1 1 0 0 1 1 1v.04a1 1 0 1 1-2 0v-.04a1 1 0 0 1 1-1ZM7 4.8v4h2v-4H7Z"
        fill="#CC0C0C"
      />
    </svg>
  ),
  alert: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 2a1 1 0 0 1 1 1v.05a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1ZM9 6v5h2V6H9Z"
        fill="currentColor"
      />
    </svg>
  ),
  wallet: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M16.071 8.674V5.27H4v10.214h12.071v-3.405"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="bevel"
      />
      <path
        d="M12 12V9h5v3h-5ZM4.928 5.27l9.655-2.787 1.04 3.102"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  edit: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="m11.381 5.08-7.7 7.7-.933 4.468 4.468-.932 7.634-7.634M11.38 5.08l3.1-3.1 3.535 3.536-3.166 3.166M11.38 5.08l3.469 3.602"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  chat: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M8.375 7.571v3.09h3.25m-3.25-3.09V4H17v8.429l-2.75-1.768h-2.625m-3.25-3.09H3V16l2.75-1.768h5.875v-3.571"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "zoom-out": (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M13.6 12.6 18 17M6.5 8.6h6m2.7 0A5.6 5.6 0 1 1 4 8.6a5.6 5.6 0 0 1 11.2 0Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "zoom-in": (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M13.6 12.6 18 17M9.6 5.5v6M6.5 8.6h6m2.7 0A5.6 5.6 0 1 1 4 8.6a5.6 5.6 0 0 1 11.2 0Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "uv-protection": (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
      <path
        d="M30 36.403a10.481 10.481 0 0 1-3.5.597C20.701 37 16 32.299 16 26.5S20.701 16 26.5 16c5.29 0 9.666 3.912 10.394 9M24.133 5.634l.879 6.3m4.322 30.974.879 6.3M48.96 24.38l-6.3.879m-30.974 4.322-6.3.879M44.52 13.895l-5.016 3.911m-24.663 19.23-5.017 3.912m7.733-25.858-3.911-5.017M35.431 7.034l-2.389 5.896M21.298 41.915l-2.388 5.896m-6.232-26.26-5.896-2.39"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M37 24.332c2.111 2.639 5.507 4.56 9 5.314C46 41.5 37 45 37 45s-9-3.5-9-15.354c3.493-.755 6.889-2.674 9-5.313Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M31.39 32.5c.934 4.39 3.353 6.95 5.11 8.285" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  waterproof: (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
      <path d="M7 46h40" stroke="currentColor" strokeWidth="2" />
      <path
        d="M22.8 17.8c0 4.32 4.2 4.32 4.2 4.32m7-4.023C34 21.903 30.86 25 27 25s-7-3.097-7-6.903c0-1.596.544-3.146 1.532-4.363L27 7l5.468 6.734A6.934 6.934 0 0 1 34 18.097Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="m27.148 42.606.708.706-1.415.001.707-.707Zm14.28-15.759.705-.708 1.417 1.41-.705.71-1.417-1.412Zm2.08-.6v-1l1 1h-1ZM26.439 41.9l14.989-15.054 1.417 1.412-14.989 15.053L26.44 41.9Zm-9.232-10.65L27.855 41.9l-1.414 1.414-10.648-10.647 1.414-1.414Zm25.3 2.906v-7.91h2v7.91h-2Zm1-6.91h-7.91v-2h7.91v2Z"
        fill="currentColor"
      />
    </svg>
  ),
  tested: (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <path
        d="M9.548 38.367C10.99 42.8 15.125 46 20 46s9.009-3.2 10.452-7.633m-20.904 0A11.185 11.185 0 0 1 9 34.898c0-1.212.192-2.378.548-3.47m0 6.94h20.904m0 0c.356-1.092.548-2.258.548-3.47 0-4.92-3.17-9.092-7.563-10.55M11.75 27.555h5.5m-5.5 0a11.116 11.116 0 0 0-2.202 3.875m2.202-3.875a11.004 11.004 0 0 1 4.813-3.205m-7.015 7.08h3.577m3.438-7.08A10.897 10.897 0 0 1 20 23.796c1.2 0 2.356.194 3.438.553m-6.875 0V12m6.875 12.349V12h1.375-9.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m39 44.745-.999-.05-.001.05h1Zm2-4.53.87-.493h-1.74l.87.492Zm2 4.51h1l-.001-.052-.999.052Zm.667-32.332h-1 1Zm-5.334.036h-1 1Zm4.334 3.357a1 1 0 1 0 2 0h-2Zm1 13.112h1-1ZM41 37.5l-.87.492h1.74L41 37.5Zm-2.826-8.602h1-1ZM44.667 20a1 1 0 1 0-2 0h2ZM41 46c-.441 0-1-.451-1-1.255h-2C38 46.415 39.23 48 41 48v-2Zm-1.001-1.205c.002-.035.024-.175.117-.453.086-.26.215-.583.383-.962.337-.756.812-1.685 1.371-2.673l-1.74-.985a34.463 34.463 0 0 0-1.458 2.845c-.185.414-.34.802-.454 1.142-.107.322-.201.671-.217.986l1.998.1Zm.13-4.088c.56.988 1.035 1.917 1.372 2.672.169.378.298.7.384.957.044.129.074.233.093.314.01.04.015.07.02.094l.003.032L44 44.673c-.016-.31-.111-.658-.218-.975a13.165 13.165 0 0 0-.453-1.135 34.828 34.828 0 0 0-1.458-2.841l-1.74.985ZM42 44.725c0 .83-.564 1.275-1 1.275v2c1.775 0 3-1.59 3-3.275h-2ZM41 10c.454 0 .837.174 1.122.511.294.35.545.95.545 1.882h2c0-1.282-.347-2.378-1.017-3.172A3.413 3.413 0 0 0 41 8v2Zm-1.667 2.429c0-.955.253-1.564.548-1.916.284-.34.665-.513 1.119-.513V8c-1.02 0-1.972.416-2.653 1.228-.67.8-1.014 1.905-1.014 3.2h2Zm3.334-.036v3.393h2v-3.393h-2Zm-5.334.036v3.357h2v-3.357h-2Zm5.334 16.47c0 1.085-.342 2.61-.856 4.166-.508 1.54-1.15 3.004-1.681 3.943l1.74.984c.61-1.076 1.3-2.666 1.84-4.3.535-1.617.957-3.385.957-4.794h-2Zm-.797 8.109c-.538-.953-1.222-2.426-1.768-3.964-.555-1.56-.928-3.075-.928-4.146h-2c0 1.424.47 3.202 1.043 4.816.581 1.635 1.311 3.215 1.913 4.278l1.74-.984Zm1.797-8.11h1V20h-2V28.898h1Zm-4.493 0V20h-2v8.898h2ZM37 16.786h8v-2h-8v2Zm8 2.071h-8v2h8v-2Zm-8 0c-.536 0-1-.447-1-1.036h-2c0 1.66 1.327 3.036 3 3.036v-2Zm9-1.036c0 .59-.464 1.036-1 1.036v2c1.673 0 3-1.376 3-3.036h-2Zm-1-1.035c.536 0 1 .447 1 1.035h2c0-1.66-1.327-3.035-3-3.035v2Zm-8-2c-1.673 0-3 1.376-3 3.035h2c0-.588.464-1.035 1-1.035v-2Z"
        fill="currentColor"
      />
    </svg>
  ),
  weight: (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <path
        d="M14.336 21.67 38.09 45.427c2.375 2.376 5.94 2.77 8.315.394 2.375-2.375 1.98-5.938-.396-8.314l-3.166-3.166M14.336 21.67l7.92-7.92m-7.92 7.92-1.583 1.585-3.167-3.167L20.672 9l3.167 3.167-1.583 1.583m0 0 4.751 4.752m0 0-3.168 3.169m3.168-3.169 3.959 3.96m-4.752 4.752 4.752-4.752m0 0 3.959 3.959m-3.168 3.168 3.168-3.168m0 0 3.959 3.96m-4.752 4.751 4.752-4.752m0 0 1.055 1.056m-.265 6.072 3.168-3.169m0 0-2.903-2.903m-16.524-.686c1.585-1.833 5.529-.37 7.918.686 2.799 1.236 7.167 1.481 8.606 0m-29.161 0C9.25 33.892 8 36.493 8 37.505c0 3.758 5.555 3.758 5.555 0 0-1.012-1.25-3.613-2.777-6.07Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  pao: (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <path
        d="M42 31.667c0 1.472-6.044 2.666-13.5 2.666S15 33.14 15 31.667m27 0C42 30.194 35.956 29 28.5 29S15 30.194 15 31.667m27 0v14.666C42 47.806 35.956 49 28.5 49S15 47.806 15 46.333V31.667M33.674 8.407c.494.777-4.205 4.651-10.495 8.654-6.29 4.003-11.79 6.618-12.284 5.841M33.674 8.407c-.494-.777-5.994 1.839-12.284 5.841-6.29 4.003-10.99 7.878-10.495 8.654M33.674 8.407l2.237 3.515c.494.777-4.205 4.651-10.495 8.654-6.29 4.003-11.79 6.618-12.284 5.841l-2.237-3.515"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  "made-in-IT": (
    <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <path
        d="M25 25.957h3.6l3.6 8.022M25 25.957c-6.6 0-15 3.128-15 4.608m15-4.608s-.993-2.655-2.18-5.85M35.8 42l-3.6-8.021m-1.532-3.413H35.8v-4.609c5.4 0 10.2 2.468 10.2 2.468V42H28.6M10 30.566V19.787S13.5 14.5 20.5 13.5c.764 2.096 1.445 4.248 2.32 6.607M10 30.566v5.88m12.82-16.34c-3.82 0-6.656 1.04-9.82 2.356m19.2 11.517c-3.302 0-6.414.129-9.237.346M10 36.447V42h12.963M10 36.447c2.435-.835 7.065-1.67 12.963-2.122m0 0V29.66m0 12.34v-4.75m0 4.75H28.6m0 0v-4.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  question: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 4.55a1 1 0 0 1-1-1v-.05a1 1 0 1 1 2 0v.05a1 1 0 0 1-1 1Zm-.97-5.374c.672-.096 1.168-.248 1.488-.456.32-.208.48-.472.48-.792 0-.264-.1-.472-.3-.624-.2-.152-.488-.228-.864-.228-.664 0-1.316.212-1.956.636L7.05 6.44a4.575 4.575 0 0 1 1.32-.732 4.615 4.615 0 0 1 1.656-.288c.92 0 1.636.208 2.148.624.512.416.768.964.768 1.644 0 .84-.328 1.468-.984 1.884a4.784 4.784 0 0 1-1.068.497v1.123H9.03V9.176Z"
        fill="currentColor"
      />
    </svg>
  ),
  "arrow-left": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 5L4 10.5M4 10.5L9.5 16M4 10.5L16 10.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "arrow-right": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 4.5L16 10M16 10L10.5 15.5M16 10H4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "chevron-down": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 7.25L10 12.75L15.5 7.25" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "chevron-left": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.75 4.5L7.25 10L12.75 15.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "chevron-right": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.25 4.5L12.75 10L7.25 15.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "chevron-up": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 12.75L10 7.25L15.5 12.75" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "double-chevron-down": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 10.25L10 15.75L15.5 10.25" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M4.5 4.25L10 9.75L15.5 4.25" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "double-chevron-up": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 9.75L10 4.25L4.5 9.75" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M15.5 15.75L10 10.25L4.5 15.75" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  close: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L16 16M16 4L4 16" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  pause: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 16L7 4M13 16L13 4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  play: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 10L7.70968 4H6.5V16H7.70968L14 10Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "play-full": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 17V3L16 10L6 17Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "play-white": (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 13V1L10 7L0 13Z"
        fill="white"
        stroke="#252B2E"
        strokeWidth="0.5"
        strokeLinejoin="bevel"
        width="10"
        height="14"
      />
    </svg>
  ),

  "play-pink": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 258.43 288"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(18,0)">
        <path
          fill="#E95485"
          d="M 16.31 0.00 L 18.95 0.00 C 23.54 0.29 27.98 1.82 31.96 4.08 
       C 102.35 44.36 172.79 84.55 243.17 124.84 
       C 249.80 128.70 256.84 134.14 258.00 142.26 
       L 258.00 144.99 C 256.69 153.74 249.17 159.68 242.13 164.09 
       C 173.53 203.53 104.90 242.90 36.30 282.32 
       C 31.38 285.14 26.03 287.34 20.36 288.00 
       L 17.00 288.00 C 11.43 287.63 6.50 283.95 4.15 278.95 
       C -0.43 269.66 0.78 259.03 0.63 249.02 
       C 0.38 225.19 0.84 201.34 0.00 177.54 
       L 0.00 18.94 C 0.39 14.24 1.63 9.40 4.76 5.74 
       C 7.56 2.26 11.93 0.39 16.31 0.00 Z"
        />
      </g>
    </svg>
  ),
  cart: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M7 6.889C7 4.74 8.343 3 10 3s3 1.741 3 3.889m-9 0h12L15 17H5L4 6.889Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "cart-quantity": (
    <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21">
      <path
        d="M7 7.38889C7 5.24111 8.34315 3.5 10 3.5C11.6569 3.5 13 5.24111 13 7.38889M4 7.38889H16L15 17.5H5L4 7.38889Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <rect x="8" y="10.5" width="12" height="10" rx="5" fill="white" />
      <path d="M14 12.375V19.375" stroke="currentColor" strokeWidth="1.6" />
      <path d="M10.5 15.8809H17.5" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  ),
  notify: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.23 9.042c0-.64.104-1.49.243-2.35C5.828 4.506 7.786 3 10 3s4.172 1.506 4.527 3.692c.14.86.242 1.71.242 2.35C14.77 11.854 17 15.5 17 15.5H3s2.23-4.167 2.23-6.458Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M8.002 16a2 2 0 1 0 4 0"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  heart: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M10.702 5.184c.13-.214.275-.41.437-.586 1.34-1.464 3.505-1.464 4.846 0 1.353 1.48 1.353 3.887 0 5.365L10 16.5 4.015 9.964c-1.353-1.479-1.353-3.887 0-5.365 1.341-1.465 3.505-1.465 4.846 0 .162.176.307.37.437.585L10 6.334l.702-1.15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "heart-path": (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <clipPath id="heart-path" clipPathUnits="objectBoundingBox">
        <path
          d="m 0.5351 0.2592 c 0.0065 -0.0107 0.0138 -0.0205 0.0219 -0.0293 c 0.067 -0.0732 0.1753 -0.0732 0.2423 0 c 0.0677 0.074 0.0677 0.1944 0 0.2683 l -0.2993 0.3269 l -0.2993 -0.3268 c -0.0677 -0.074 -0.0677 -0.1944 0 -0.2683 c 0.067 -0.0733 0.1753 -0.0733 0.2423 0 c 0.0081 0.0088 0.0154 0.0185 0.0219 0.0292 l 0.0351 0.0575 l 0.0351 -0.0575 z"
          fill="currentColor"
        />
      </clipPath>
    </svg>
  ),
  plus: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M4 10h12m-6 6V4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  minus: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  account: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M18 18.05h.05V17.2a4.85 4.85 0 0 0-4.85-4.85H6.8a4.85 4.85 0 0 0-4.85 4.85V18.05H18ZM12.35 6.4c0 1.558-1.094 2.75-2.35 2.75S7.65 7.958 7.65 6.4 8.744 3.65 10 3.65s2.35 1.192 2.35 2.75Zm-6.4 0c0 2.453 1.809 4.45 4.05 4.45 2.241 0 4.05-1.997 4.05-4.45 0-2.453-1.809-4.45-4.05-4.45-2.241 0-4.05 1.997-4.05 4.45Zm-2.184 9.95a3.151 3.151 0 0 1 3.034-2.3h6.4c1.445 0 2.663.973 3.034 2.3H3.766Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth=".1"
      />
    </svg>
  ),
  search: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6 12.6L18 17M15.2 8.6C15.2 11.6928 12.6928 14.2 9.6 14.2C6.50721 14.2 4 11.6928 4 8.6C4 5.50721 6.50721 3 9.6 3C12.6928 3 15.2 5.50721 15.2 8.6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  menu: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M17 15v2H0v-2h17Zm-5-6v2H0V9h12Zm8-6v2H0V3h20Z" fill="currentColor" />
    </svg>
  ),
  filters: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 13.5L18 13.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M11 6.5L2 6.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M2 13.5H4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M18 6.5L16 6.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <circle
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="matrix(1 0 0 -1 10.5 9)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <circle
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="matrix(1 0 0 -1 4.5 16)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  sort: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 13.7438L6 17.5M6 17.5L2 13.7438M6 17.5L6 3.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M10 6.25621L14 2.5M14 2.5L18 6.25621M14 2.5L14 16.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "star-empty": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99946 2.5L12.4728 7.43757L18 8.22928L14.0008 12.0729L14.944 17.5L9.99946 14.9376L5.05707 17.5L6.00027 12.0729L2 8.22928L7.52827 7.43757L9.99946 2.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  "star-25-filled": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99946 2.5L12.4728 7.43757L18 8.22928L14.0008 12.0729L14.944 17.5L9.99946 14.9376L5.05707 17.5L6.00027 12.0729L2 8.22928L7.52827 7.43757L9.99946 2.5Z"
        fill="currentColor"
      />
      <path d="M6.00027 12.0734L5.05707 17.5004L7 16.4931V7.51367L2 8.22973L6.00027 12.0734Z" fill="currentColor" />
    </svg>
  ),
  "star-half": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99946 2.5L12.4728 7.43757L18 8.22928L14.0008 12.0729L14.944 17.5L9.99946 14.9376L5.05707 17.5L6.00027 12.0729L2 8.22928L7.52827 7.43757L9.99946 2.5Z"
        fill="currentColor"
      />
      <path
        d="M5.05707 17.5L9.99946 14.9376V2.5L7.52827 7.43757L2 8.22928L6.00027 12.0729L5.05707 17.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  "star-75-filled": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99946 2.5L12.4728 7.43757L18 8.22928L14.0008 12.0729L14.944 17.5L9.99946 14.9376L5.05707 17.5L6.00027 12.0729L2 8.22928L7.52827 7.43757L9.99946 2.5Z"
        fill="currentColor"
      />
      <path
        d="M12.4728 7.43757L9.99946 2.5L7.52827 7.43757L2 8.22928L6.00027 12.0729L5.05707 17.5L9.99946 14.9376L12.9864 16.4855V7.51114L12.4728 7.43757Z"
        fill="currentColor"
      />
    </svg>
  ),
  "star-full": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99946 2.5L12.4728 7.43757L18 8.22928L14.0008 12.0729L14.944 17.5L9.99946 14.9376L5.05707 17.5L6.00027 12.0729L2 8.22928L7.52827 7.43757L9.99946 2.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  youtube: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g fill="currentColor" clipPath="url(#a)">
        <path d="m8.466 8.054 3.92 2.23-3.92 2.23v-4.46Z" />
        <path
          fillRule="evenodd"
          d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm16.641 3.92a1.886 1.886 0 0 0-1.326-1.335C14.688 5 10 5 10 5s-4.688 0-5.86.315A1.885 1.885 0 0 0 2.814 6.65C2.5 7.828 2.5 10.284 2.5 10.284s0 2.456.314 3.634a1.886 1.886 0 0 0 1.326 1.335c1.173.315 5.86.315 5.86.315s4.688 0 5.86-.315a1.885 1.885 0 0 0 1.326-1.335c.314-1.178.314-3.634.314-3.634s0-2.456-.314-3.634Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  "youtube-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g fill="#FF0302" clipPath="url(#a)">
        <path d="m8.466 8.054 3.92 2.23-3.92 2.23v-4.46Z" />
        <path
          fillRule="evenodd"
          d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm16.641 3.92a1.886 1.886 0 0 0-1.326-1.335C14.688 5 10 5 10 5s-4.688 0-5.86.315A1.885 1.885 0 0 0 2.814 6.65C2.5 7.828 2.5 10.284 2.5 10.284s0 2.456.314 3.634a1.886 1.886 0 0 0 1.326 1.335c1.173.315 5.86.315 5.86.315s4.688 0 5.86-.315a1.885 1.885 0 0 0 1.326-1.335c.314-1.178.314-3.634.314-3.634s0-2.456-.314-3.634Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  "virtual-try-on": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="bevel"
        strokeWidth="2"
        d="M7 14c0-.5.895-1.5 2-1.5h2c1.105 0 2 .5 2 1.5m-3-8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      />
      <path stroke="currentColor" strokeWidth="2" d="M7.5 3h-4v4M7.5 17h-4v-4M12.5 3h4v4M12.5 17h4v-4" />
    </svg>
  ),
  twitter: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 5.19974 0 3.79961 0.544967 2.73005C1.02433 1.78924 1.78924 1.02433 2.73005 0.544967C3.79961 0 5.19974 0 8 0H12C14.8003 0 16.2004 0 17.27 0.544967C18.2108 1.02433 18.9757 1.78924 19.455 2.73005C20 3.79961 20 5.19974 20 8V12C20 14.8003 20 16.2004 19.455 17.27C18.9757 18.2108 18.2108 18.9757 17.27 19.455C16.2004 20 14.8003 20 12 20H8C5.19974 20 3.79961 20 2.73005 19.455C1.78924 18.9757 1.02433 18.2108 0.544967 17.27C0 16.2004 0 14.8003 0 12V8ZM16.1726 4H14.0258L10.4883 7.83446L7.4298 4H3L8.29291 10.5631L3.27646 16H5.42451L9.2962 11.8049L12.6799 16H17L11.4825 9.08308L16.1726 4ZM14.4619 14.7815H13.2724L5.50693 5.15446H6.78343L14.4619 14.7815Z"
        fill="currentColor"
      />
    </svg>
  ),
  "video-consultation": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path stroke="currentColor" strokeLinejoin="bevel" strokeWidth="2" d="M2 4h16v12H2z" />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="bevel"
        strokeWidth="2"
        d="M8 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
      />
    </svg>
  ),
  tiktok: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm11.01.606c-.433.001-.868.002-1.305.008-.01 1.396-.01 2.792-.01 4.19v2.516c-.002.262-.002.523-.001.784.001.731.002 1.461-.039 2.194-.005.204-.108.383-.209.556l-.018.033c-.323.527-.917.888-1.54.894-.933.083-1.81-.683-1.944-1.595 0-.046-.002-.093-.004-.14-.008-.255-.016-.515.082-.754a1.93 1.93 0 0 1 .756-.972c.483-.333 1.127-.383 1.677-.206 0-.352.007-.704.013-1.057.008-.47.016-.94.01-1.41-1.206-.227-2.495.156-3.417.956a4.17 4.17 0 0 0-1.433 2.756c-.011.272-.006.55.005.827.117 1.3.906 2.512 2.028 3.173a4.05 4.05 0 0 0 2.267.572c1.294-.022 2.555-.717 3.283-1.783.45-.64.705-1.412.75-2.19.01-1.01.01-2.022.01-3.036 0-.608-.001-1.216.001-1.824.289.189.583.372.9.516.728.345 1.533.511 2.333.54v-2.24c-.855-.094-1.733-.377-2.355-.994-.622-.6-.928-1.467-.972-2.317-.29.003-.578.003-.868.003Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  "store-locator": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M12.798 14.455A23.728 23.728 0 0 1 10 17a23.725 23.725 0 0 1-2.798-2.545C5.192 12.3 4 10.129 4 8.137 4 4.662 6.56 2 10 2s6 2.663 6 6.137c0 1.992-1.191 4.162-3.202 6.318Z"
      />
      <circle cx="10" cy="8" r="2" fill="currentColor" />
    </svg>
  ),
  "store-locator-selected": (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.523 16.583a23.728 23.728 0 0 0 2.275-2.128C14.808 12.3 16 10.129 16 8.137 16 4.663 13.44 2 10 2S4 4.662 4 8.137c0 1.992 1.191 4.162 3.202 6.318A23.725 23.725 0 0 0 10 17c.164-.127.339-.266.523-.417ZM10 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        fill="currentColor"
      />
      <path
        d="M12.798 14.455A23.728 23.728 0 0 1 10 17a23.725 23.725 0 0 1-2.798-2.545C5.192 12.3 4 10.129 4 8.137 4 4.662 6.56 2 10 2s6 2.663 6 6.137c0 1.992-1.191 4.162-3.202 6.318Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  suncare: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M10.694 13.999s-.06.047-.52.047c-2.178 0-3.943-1.752-3.943-3.913 0-2.16 1.765-3.913 3.943-3.913 1.595 0 2.968.94 3.59 2.29l.02.032M9.02 1l.376 2.689M3.695 11.22 1 11.595m12.854-9.997-1.021 2.516m-5.025 12.37L6.786 19M4.12 7.793l-2.522-1.02m16.144-2.246-2.147 1.669M5.044 14.403l-2.146 1.669M6.206 5.036l-1.673-2.14M18 10.692c-1.523-.357-3.003-1.266-3.923-2.515-.92 1.249-2.4 2.157-3.923 2.515 0 5.61 3.923 7.267 3.923 7.267S18 16.303 18 10.692Z"
      />
    </svg>
  ),
  "skin-diagnostic": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinejoin="bevel"
        strokeWidth="2"
        d="m11.54 13.54 3.96 3.96m-5-10.538A4.107 4.107 0 1 0 12.563 9.5m.437-7s-2.5 3-2.5 4.5 1 2.5 2.5 2.5 2.5-1 2.5-2.5S13 2.5 13 2.5Z"
      />
    </svg>
  ),
  "skincare-advisor": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="m11.136 15.07-.967.255.967-.255Zm2.8-4.933.264.965-.263-.965ZM18 11.47l-.077.997.852-1.628-.775.631ZM14.3 18l-.17.985 1.022-1.508L14.3 18Zm-11.593.707 16-16-1.414-1.414-16 16 1.414 1.414ZM6.308 9.22c0-1.134.94-2.08 2.132-2.08v-2c-2.266 0-4.132 1.811-4.132 4.08h2ZM8.44 7.14c.574 0 .881.027 1.166.316l1.426-1.402c-.926-.942-2.046-.915-2.592-.915v2Zm-1.754 3.276c-.354-.365-.378-.91-.378-1.196h-2c0 .275-.024 1.592.942 2.588l1.436-1.393Zm5.417 4.4c-.43-1.63.526-3.285 2.097-3.713l-.526-1.93c-2.656.724-4.208 3.486-3.505 6.153l1.934-.51Zm2.097-3.713c1.136-.31 2.3.11 3.025 1l1.55-1.263c-1.19-1.46-3.15-2.199-5.101-1.667l.526 1.93Zm.27 5.913a2.987 2.987 0 0 1-2.367-2.2l-1.934.51a4.987 4.987 0 0 0 3.96 3.66l.341-1.97Zm.682.462c-1.416-2.307.412-5.192 2.77-5.01l.155-1.994c-4.156-.32-6.81 4.497-4.63 8.05l1.705-1.046ZM2.362 4.602l1.632 1.596 1.398-1.43-1.631-1.595-1.399 1.43ZM.82 8.928l2.267.417.362-1.967-2.267-.417-.362 1.967Zm.821 4.018 2.177-.748-.65-1.892-2.176.748.65 1.892ZM5.877 2.264l.598 2.18 1.929-.528-.598-2.18-1.929.528Zm4.159-.528-.598 2.18 1.93.528.596-2.18-1.928-.528Z"
      />
    </svg>
  ),
  shipping: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m1 4 1-1h11l1 1v2h2.5l.858.486 1.5 2.5L19 9.5V14l-1 1h-1.17a3.001 3.001 0 0 1-5.66 0H8.83a3.001 3.001 0 0 1-5.66 0H2l-1-1V4Zm15.83 9H17V9.777L15.934 8H14v3c1.306 0 2.418.835 2.83 2ZM14 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2-1.236V5H3v8h.17a3.001 3.001 0 0 1 5.66 0h2.34c.17-.48.459-.904.83-1.236ZM5 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  shop: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M12.798 14.455A23.728 23.728 0 0 1 10 17a23.725 23.725 0 0 1-2.798-2.545C5.192 12.3 4 10.129 4 8.137 4 4.662 6.56 2 10 2s6 2.663 6 6.137c0 1.992-1.191 4.162-3.202 6.318Z"
      />
      <path
        fill="currentColor"
        d="M10.303 8.026c1.182-.673 2.36-1.352 3.547-2.02-.516-.012-1.032-.002-1.549-.005-1.386.827-2.78 1.645-4.174 2.465 0-.821-.004-1.643.003-2.464-.377-.003-.754 0-1.13-.001v4.998h1.128c-.005-.575 0-1.15-.003-1.725.455-.27.92-.528 1.375-.796 1.007.836 2.002 1.682 3.004 2.522.499-.004.998.005 1.496-.005a836.35 836.35 0 0 1-3.697-2.969Z"
      />
    </svg>
  ),
  "skin-coach": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="bevel"
        strokeWidth="2"
        d="M5 17c0-.667 1.492-2 3.333-2h3.334c1.84 0 3.333.667 3.333 2M10 6.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 11.5c0 1-.5 1.5-1 1.5.5 0 1 .5 1 1.5 0-1 .5-1.5 1-1.5-.5 0-1-.5-1-1.5ZM17 6c0 1-.5 1.5-1 1.5.5 0 1 .5 1 1.5 0-1 .5-1.5 1-1.5-.5 0-1-.5-1-1.5Z"
      />
    </svg>
  ),
  "seasonal-palette": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m3 1.498-1 1v11.807a3.505 3.505 0 0 0 1.143 3.28 3.487 3.487 0 0 0 2.937.865c.65.046 1.32-.089 1.933-.426l10.355-5.705.394-1.359-2.413-4.38-1.358-.393-.029.016.03-.049-.324-1.376-4.253-2.63-1.376.325L9 2.536v-.038l-1-1H3Zm6 4.84v5.705l3.765-6.09-2.551-1.578L9 6.34Zm-5 8.66v-11.5h3v11.5a1.5 1.5 0 1 1-3 0Zm12.527-3.949L9.61 14.861l3.212-5.195 2.259-1.244 1.447 2.627Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  share: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.5 5.5a1.5 1.5 0 1 1 2.999 0 1.5 1.5 0 0 1-2.999 0ZM14 2a3.5 3.5 0 0 0-3.45 4.09L7.51 7.562a3.5 3.5 0 1 0 0 4.877l3.04 1.471a3.5 3.5 0 1 0 .886-1.793l-3-1.451a3.518 3.518 0 0 0 0-1.33l3.001-1.452A3.5 3.5 0 1 0 14 2Zm-1.5 12.498a1.5 1.5 0 1 1 2.999 0 1.5 1.5 0 0 1-2.999 0ZM5 8.5a1.5 1.5 0 1 0 0 2.999A1.5 1.5 0 0 0 5 8.5Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  package: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinejoin="bevel"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M16 6.111V16H4V6.111m12 0L14.252 3h-8.55L4 6.111m12 0H4M10 3v3"
      />
    </svg>
  ),
  "pick-up": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M12.332 12.964A19.495 19.495 0 0 1 10 15a19.49 19.49 0 0 1-2.331-2.036C5.993 11.24 5 9.504 5 7.91 5 5.13 7.133 3 10 3s5 2.13 5 4.91c0 1.593-.993 3.33-2.668 5.054Z"
      />
      <circle cx="10" cy="7.5" r="1.5" fill="currentColor" />
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M7.138 12c-.438.073-.853.163-1.238.267-1.757.475-2.9 1.247-2.9 2.12C3 15.83 6.134 17 10 17s7-1.17 7-2.614c0-.872-1.143-1.644-2.9-2.119-.385-.104-.8-.194-1.238-.267"
      />
    </svg>
  ),
  instagram: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g fill="currentColor" clipPath="url(#a)">
        <path d="M12.425 10a2.424 2.424 0 1 0-4.849 0 2.424 2.424 0 0 0 4.849 0Z" />
        <path
          fillRule="evenodd"
          d="M9.758 4.038h-.41v-.002c-1.355.002-1.615.01-2.286.041-.71.033-1.094.15-1.35.25-.34.133-.583.29-.837.545a2.253 2.253 0 0 0-.544.836c-.1.257-.218.642-.25 1.35-.036.767-.043.996-.043 2.939 0 1.942.007 2.172.042 2.939.033.709.151 1.094.25 1.35.133.34.29.581.545.835.254.255.497.413.836.544.257.1.642.219 1.35.251.767.035.997.043 2.94.043 1.941 0 2.171-.008 2.938-.043.71-.032 1.094-.15 1.35-.25.34-.132.582-.29.836-.544a2.25 2.25 0 0 0 .544-.836c.1-.256.218-.64.25-1.35.036-.767.043-.997.043-2.938 0-1.94-.007-2.17-.042-2.938-.033-.709-.151-1.093-.25-1.35a2.257 2.257 0 0 0-.545-.836 2.25 2.25 0 0 0-.836-.544c-.256-.1-.64-.218-1.35-.25-.767-.035-.997-.042-2.939-.042h-.242Zm3.252 2.08a.873.873 0 1 1 1.745 0 .873.873 0 0 1-1.745 0ZM6.266 10a3.735 3.735 0 1 1 7.47 0 3.735 3.735 0 0 1-7.47 0Z"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.186C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.186C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm6.457.041c.775-.035 1.023-.044 2.998-.044h-.002c1.976 0 2.223.009 2.998.044.775.036 1.303.158 1.767.338.479.186.883.434 1.288.839.405.404.653.81.84 1.288.178.462.3.991.337 1.765.035.776.044 1.024.044 2.999s-.009 2.222-.044 2.998c-.036.774-.159 1.303-.338 1.765a3.568 3.568 0 0 1-.84 1.289c-.403.404-.808.653-1.286.839-.463.18-.992.302-1.766.338-.776.035-1.023.044-2.999.044-1.974 0-2.222-.009-2.998-.044-.774-.036-1.303-.158-1.765-.338a3.56 3.56 0 0 1-1.288-.84 3.563 3.563 0 0 1-.839-1.288c-.18-.462-.302-.99-.338-1.765-.035-.776-.044-1.023-.044-2.998 0-1.975.01-2.223.044-2.999.035-.774.158-1.303.338-1.765a3.57 3.57 0 0 1 .84-1.288c.404-.405.81-.653 1.288-.839.462-.18.99-.302 1.765-.338Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  "kiko-id": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.5 4.5H11a5.5 5.5 0 1 1 0 11H6.5v-11Zm2 2v7H11a3.5 3.5 0 1 0 0-7H8.5Zm-5 9v-8h2v8h-2Zm2-11h-2v2h2v-2Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  "marvel-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="10" fill="#ED1D24" />
      <path
        fill="#fff"
        d="M16.152 8.094V7h-3.045l-.5 3.655L12.11 7h-1.098l.123.975C11.01 7.725 10.56 7 9.571 7h-1.1l-.004 5.327L7.667 7l-1.438-.001-.828 5.52V7H4.026L3.53 10.1 3.046 7H1.669V13h1.084v-2.893l.494 2.893h.576l.486-2.893v2.893H6.4l.127-.923h.841l.127.923 2.051.001h.005v-1.949l.251-.037.52 1.986H11.386l-.683-2.329c.347-.256.738-.906.634-1.529 0 .008.645 3.86.645 3.86l1.262-.003.862-5.44v5.44h2.047v-1.08h-.972v-1.376h.972V9.45h-.972V8.094h.972Zm-9.499 3.032.298-2.566.31 2.566h-.608ZM9.805 9.94a.585.585 0 0 1-.256.06v-1.93h.006c.085 0 .718.026.718.955 0 .486-.216.793-.468.915Zm8.531 1.98V13H16.34V6.998h1.075v4.922h.921Z"
      />
    </svg>
  ),
  "instagram-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g clipPath="url(#a)">
        <path fill="url(#b)" d="M12.425 10a2.424 2.424 0 1 0-4.849 0 2.424 2.424 0 0 0 4.849 0Z" />
        <path
          fill="url(#c)"
          fillRule="evenodd"
          d="M9.758 4.038h-.41v-.002c-1.355.002-1.615.01-2.286.041-.71.033-1.094.15-1.35.25-.34.133-.583.29-.837.545a2.253 2.253 0 0 0-.544.836c-.1.257-.218.642-.25 1.35-.036.767-.043.996-.043 2.939 0 1.942.007 2.172.042 2.939.033.709.151 1.094.25 1.35.133.34.29.581.545.835.254.255.497.413.836.544.257.1.642.219 1.35.251.767.035.997.043 2.94.043 1.941 0 2.171-.008 2.938-.043.71-.032 1.094-.15 1.35-.25.34-.132.582-.29.836-.544a2.25 2.25 0 0 0 .544-.836c.1-.256.218-.64.25-1.35.036-.767.043-.997.043-2.938 0-1.94-.007-2.17-.042-2.938-.033-.709-.151-1.093-.25-1.35a2.257 2.257 0 0 0-.545-.836 2.25 2.25 0 0 0-.836-.544c-.256-.1-.64-.218-1.35-.25-.767-.035-.997-.042-2.939-.042h-.242Zm3.252 2.08a.873.873 0 1 1 1.745 0 .873.873 0 0 1-1.745 0ZM6.266 10a3.735 3.735 0 1 1 7.47 0 3.735 3.735 0 0 1-7.47 0Z"
          clipRule="evenodd"
        />
        <path
          fill="url(#d)"
          fillRule="evenodd"
          d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.186C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.186C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm6.457.041c.775-.035 1.023-.044 2.998-.044h-.002c1.976 0 2.223.009 2.998.044.775.036 1.303.158 1.767.338.479.186.883.434 1.288.839.405.404.653.81.84 1.288.178.462.3.991.337 1.765.035.776.044 1.024.044 2.999s-.009 2.222-.044 2.998c-.036.774-.159 1.303-.338 1.765a3.568 3.568 0 0 1-.84 1.289c-.403.404-.808.653-1.286.839-.463.18-.992.302-1.766.338-.776.035-1.023.044-2.999.044-1.974 0-2.222-.009-2.998-.044-.774-.036-1.303-.158-1.765-.338a3.56 3.56 0 0 1-1.288-.84 3.563 3.563 0 0 1-.839-1.288c-.18-.462-.302-.99-.338-1.765-.035-.776-.044-1.023-.044-2.998 0-1.975.01-2.223.044-2.999.035-.774.158-1.303.338-1.765a3.57 3.57 0 0 1 .84-1.288c.404-.405.81-.653 1.288-.839.462-.18.99-.302 1.765-.338Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient id="b" x1="11.75" x2="5.906" y1="-1.06" y2="18.249" gradientUnits="userSpaceOnUse">
          <stop stopColor="#515BD4" />
          <stop offset=".26" stopColor="#9510B8" />
          <stop offset=".66" stopColor="#E51804" />
          <stop offset="1" stopColor="#FFBF00" />
        </linearGradient>
        <linearGradient id="c" x1="11.75" x2="5.906" y1="-1.06" y2="18.249" gradientUnits="userSpaceOnUse">
          <stop stopColor="#515BD4" />
          <stop offset=".26" stopColor="#9510B8" />
          <stop offset=".66" stopColor="#E51804" />
          <stop offset="1" stopColor="#FFBF00" />
        </linearGradient>
        <linearGradient id="d" x1="11.75" x2="5.906" y1="-1.06" y2="18.249" gradientUnits="userSpaceOnUse">
          <stop stopColor="#515BD4" />
          <stop offset=".26" stopColor="#9510B8" />
          <stop offset=".66" stopColor="#E51804" />
          <stop offset="1" stopColor="#FFBF00" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  "google-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#4285F4"
        d="M20 10.226c0-.659-.06-1.284-.162-1.892h-9.621v3.758h5.508c-.246 1.234-.97 2.275-2.043 2.984l3.287 2.5c1.924-1.742 3.03-4.309 3.03-7.35Z"
      />
      <path
        fill="#34A853"
        d="M10.216 20c2.76 0 5.066-.9 6.752-2.425l-3.286-2.5c-.92.6-2.086.966-3.466.966-2.665 0-4.92-1.758-5.73-4.133l-3.388 2.575C2.775 17.75 6.223 20 10.216 20Z"
      />
      <path
        fill="#FBBC05"
        d="M4.487 11.91A5.69 5.69 0 0 1 4.163 10c0-.666.12-1.307.324-1.907L1.098 5.518A9.714 9.714 0 0 0 0 10c0 1.617.4 3.133 1.098 4.483l3.389-2.575Z"
      />
      <path
        fill="#EA4335"
        d="M10.216 3.958c1.508 0 2.853.509 3.917 1.5l2.912-2.85C15.282.992 12.975 0 10.216 0 6.223 0 2.775 2.25 1.098 5.517l3.388 2.575c.81-2.375 3.065-4.134 5.73-4.134Z"
      />
    </svg>
  ),
  google: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M20 10.226c0-.659-.06-1.284-.162-1.892h-9.621v3.758h5.508c-.246 1.234-.97 2.275-2.043 2.984l3.287 2.5c1.924-1.742 3.03-4.309 3.03-7.35Z"
      />
      <path
        fill="currentColor"
        d="M10.216 20c2.76 0 5.066-.9 6.752-2.425l-3.286-2.5c-.92.6-2.086.966-3.466.966-2.665 0-4.92-1.758-5.73-4.133l-3.388 2.575C2.775 17.75 6.223 20 10.216 20Z"
      />
      <path
        fill="currentColor"
        d="M4.487 11.91A5.69 5.69 0 0 1 4.163 10c0-.666.12-1.307.324-1.907L1.098 5.518A9.714 9.714 0 0 0 0 10c0 1.617.4 3.133 1.098 4.483l3.389-2.575ZM10.216 3.958c1.508 0 2.853.509 3.917 1.5l2.912-2.85C15.282.992 12.975 0 10.216 0 6.223 0 2.775 2.25 1.098 5.517l3.388 2.575c.81-2.375 3.065-4.134 5.73-4.134Z"
      />
    </svg>
  ),
  "green-vegan": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="10" fill="url(#a)" />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.531 8.469 5.101 14.9M6.3 13.7c-2.706-4.51.902-9.02 8.569-8.569.45 7.667-4.06 11.275-8.57 8.57Z"
      />
      <defs>
        <linearGradient id="a" x1="0" x2="20" y1="10" y2="10" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE0DF" />
          <stop offset=".577" stopColor="#F9DAEF" />
          <stop offset="1" stopColor="#ECE7F9" />
        </linearGradient>
      </defs>
    </svg>
  ),
  gift: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" aria-hidden>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.999 7.812c.042-1.585-.904-4.761-3.245-4.811-1.782-.039-2.418 1.58-2.418 2.312 0 .733.445 2.5 2.704 2.5m2.959 0H7.04m2.959 0V17H4.125a1 1 0 0 1-.994-1.117l.847-7.188a1 1 0 0 1 .993-.883h2.07M10 17h5.874a1 1 0 0 0 .994-1.117l-.847-7.188a1 1 0 0 0-.993-.883h-2.07m0 0h-2.958c-.042-1.585.904-4.761 3.245-4.811 1.782-.039 2.418 1.58 2.418 2.312 0 .733-.445 2.5-2.704 2.5Z"
      />
    </svg>
  ),
  "foundation-finder": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M17 10h-7m7 0c0-.88-.163-1.724-.46-2.5M17 10c0 .88-.163 1.724-.46 2.5M10 7.5h6.54m0 0A7.008 7.008 0 0 0 14.9 5M10 5h4.899m0 0a7 7 0 1 0 0 10M10 12.5h6.54m0 0c-.363.95-.927 1.8-1.641 2.5M10 15h4.899"
      />
    </svg>
  ),
  "gift-card": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M2 15V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1Z"
      />
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="m6.59 6.97.009-.002a1.813 1.813 0 0 1 1.45.266l.009.005c.413.29.917.881 1.339 1.524l1.064 1.626-1.942-.079a5.633 5.633 0 0 1-2.218-.554l-.007-.003a1.405 1.405 0 0 1-.523-.472 1.735 1.735 0 0 1-.265-.617V8.66c-.038-.182-.118-.72.276-1.187l.005-.006c.21-.245.49-.419.803-.498Z"
      />
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="m13.631 6.97-.01-.002a1.813 1.813 0 0 0-1.45.266l-.008.005c-.414.29-.918.881-1.339 1.524L9.76 10.39l1.942-.079a5.633 5.633 0 0 0 2.219-.554l.007-.003c.262-.13.433-.34.523-.472.11-.162.213-.371.264-.617l.001-.003c.038-.182.118-.72-.276-1.187l-.005-.006a1.56 1.56 0 0 0-.803-.498Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth="2"
        d="m10.098 10.1 2.437 2.438M10.098 10.1 7.66 12.538"
      />
    </svg>
  ),
  "fondazione-umberto-veronesi-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="10" fill="#007FA6" />
      <path
        fill="#fff"
        d="M13.886 4.424c-.86.064-1.91.683-2.724 1.61-.67.763-1.197 1.63-1.645 2.703-.144.35-.452 1.25-.503 1.472a.402.402 0 0 1-.043.124c-.009 0-.022-.036-.03-.081a5.344 5.344 0 0 0-.3-.848c-.187-.382-.261-.465-.692-.78-.212-.156-.407-.283-.43-.283-.028 0-.056.022-.07.052-.02.045-.01.066.082.186.217.276.362.544.53.966.233.591.438 1.448.55 2.283l.026.197.312.279c.172.154.328.278.35.278.025 0 .077-.062.15-.178.882-1.403 1.88-2.598 2.754-3.298.13-.105.24-.206.24-.22 0-.033-.576-.564-.643-.596-.045-.022-.124.032-.433.289-.248.203-.826.79-1.103 1.114-.139.163-.255.293-.257.289-.004-.002.05-.154.118-.336.396-1.046.878-1.92 1.48-2.676.658-.829 1.495-1.475 2.22-1.713.395-.129.447-.137.824-.137.368 0 .463.015.713.122.099.04.107.051.21.26.197.404.268.817.248 1.436-.012.437-.06.748-.186 1.253-.405 1.622-1.204 3.007-2.45 4.254-1.59 1.585-3.594 2.562-5.378 2.615-.827.026-1.44-.096-2.08-.409-.358-.175-.42-.225-.585-.454a3.206 3.206 0 0 1-.53-1.279 4.3 4.3 0 0 1 0-1.075c.282-1.724 1.69-3.63 3.698-4.993.28-.19.642-.398 1.039-.597.295-.148.387-.204.392-.238.004-.032-.071-.113-.311-.328-.272-.244-.323-.28-.368-.27-.03.01-.18.075-.334.15-1.348.66-2.665 1.75-3.592 2.982-.686.906-1.125 1.853-1.273 2.737a4.684 4.684 0 0 0 0 1.2c.101.56.347 1.069.746 1.542.205.242.94.902 1.188 1.067.746.49 1.735.73 2.712.657a6.263 6.263 0 0 0 1.639-.325c1.561-.506 3.118-1.575 4.292-2.95a9.007 9.007 0 0 0 1.76-3.101c.403-1.23.493-2.234.27-3.048a2.586 2.586 0 0 0-.39-.763 11.871 11.871 0 0 0-.901-.824 1.77 1.77 0 0 0-.816-.31 2.103 2.103 0 0 0-.476-.007Z"
      />
    </svg>
  ),
  facebook: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h1.914v-7.582H7.078V9.226h2.836V6.792c0-2.769 1.668-4.298 4.22-4.298 1.221 0 2.5.216 2.5.216v2.718h-1.409c-1.387 0-1.82.852-1.82 1.725v2.072h3.098l-.495 3.194h-2.603v7.578c1.897-.015 2.991-.097 3.865-.542a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Z"
      />
    </svg>
  ),
  "facebook-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#1877F2"
        d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h1.914v-7.582H7.078V9.226h2.836V6.792c0-2.769 1.668-4.298 4.22-4.298 1.221 0 2.5.216 2.5.216v2.718h-1.409c-1.387 0-1.82.852-1.82 1.725v2.072h3.098l-.495 3.194h-2.603v7.578c1.897-.015 2.991-.097 3.865-.542a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Z"
      />
    </svg>
  ),
  "engraving-color": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        fill="none"
        strokeLinecap="square"
        strokeWidth="2"
        d="M10 11h2.248L13 8V3.5H7V8l.744 3zm0 0H8.5v2.5l1.5 2 1.5-2V11Zm-3 5.5H3m10 0h4"
      />
      <clipPath id="rainbowCircleClip">
        <path d="M14.75 1.75A3.75 3.75 0 0 0 11 5.5a3.75 3.75 0 0 0 3.75 3.75A3.75 3.75 0 0 0 18.5 5.5a3.75 3.75 0 0 0-3.75-3.75zm0 2.5A1.25 1.25 0 0 1 16 5.5a1.25 1.25 0 0 1-1.25 1.25A1.25 1.25 0 0 1 13.5 5.5a1.25 1.25 0 0 1 1.25-1.25z" />
      </clipPath>
      <foreignObject x="0" y="0" width="100%" height="100%" clipPath="url(#rainbowCircleClip)">
        <div
          className="gradient"
          style={{
            position: "relative",
            top: "-22.5%",
            left: "22.5%",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundImage:
              "conic-gradient(from 270deg, #ff4800 10%, #dfd902 35%, #20dc68, #0092f4, #da54d8 72% 75%, #ff4800 95%)",
          }}
        />
      </foreignObject>
    </svg>
  ),
  appointment: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7.5 2.5v4m5-4v4M3 9V4.5h14V9M3 9v8.5h14V9M3 9h14"
      />
    </svg>
  ),
  apple: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M17.665 15.586a11.05 11.05 0 0 1-1.022 1.933c-.537.807-.976 1.365-1.315 1.674-.525.509-1.088.77-1.69.784-.434 0-.955-.13-1.563-.392-.609-.262-1.169-.392-1.681-.392-.537 0-1.113.13-1.729.392-.617.263-1.114.4-1.494.413-.578.026-1.154-.242-1.729-.805-.367-.337-.826-.914-1.376-1.733-.59-.874-1.075-1.888-1.455-3.043C2.204 13.169 2 11.96 2 10.79c0-1.34.275-2.496.826-3.465a4.986 4.986 0 0 1 1.73-1.842 4.48 4.48 0 0 1 2.339-.695c.459 0 1.061.15 1.809.443.746.295 1.225.444 1.435.444.157 0 .689-.175 1.591-.523.853-.323 1.573-.457 2.163-.404 1.598.135 2.799.799 3.597 1.994-1.43.912-2.136 2.189-2.122 3.827.013 1.276.452 2.338 1.316 3.181.392.392.83.694 1.316.909-.105.322-.217.63-.335.927ZM13.999.4c0 1-.347 1.934-1.038 2.799-.835 1.027-1.845 1.621-2.94 1.527a3.266 3.266 0 0 1-.022-.379c0-.96.397-1.987 1.102-2.828.352-.425.8-.779 1.342-1.061C12.986.18 13.498.026 13.98 0c.014.134.02.267.02.4Z"
      />
    </svg>
  ),
  "ai-makeup-advisor": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path stroke="currentColor" strokeWidth="2" d="M7.5 3h-4v4M7.5 17h-4v-4M12.5 3h4v4" />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7.5 14v-3h1m4 3v-3h-1m-3 0V8.167l3-2.168V11m-3 0h3"
      />
      <path stroke="currentColor" strokeWidth="2" d="M12.5 17h4v-4" />
    </svg>
  ),
  checkmark: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path d="M4 9.23 8.364 13 16 6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "checkmark-gradient": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g id="Icon">
        <path
          id="Vector 410"
          d="M4.83331 9.31842L9.19695 13.0876L16.8333 6.08765"
          stroke="url(#paint0_linear_1548_5640)"
          strokeWidth="2"
          strokeLinejoin="bevel"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1548_5640"
          x1="4.83331"
          y1="9.58765"
          x2="16.8333"
          y2="9.58765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB06AD" />
          <stop offset="0.296875" stopColor="#DA0C9B" />
          <stop offset="1" stopColor="#D44102" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "checkmark-gradient-v2": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g id="Icon">
        <path
          id="Vector 410"
          d="M4.83331 9.31842L9.19695 13.0876L16.8333 6.08765"
          stroke="url(#paint0_linear_1548_5640_v2)"
          strokeWidth="2"
          strokeLinejoin="bevel"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1548_5640_v2"
          x1="4.83331"
          y1="9.58765"
          x2="16.8333"
          y2="9.58765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB06AD" />
          <stop offset="0.296875" stopColor="#DA0C9B" />
          <stop offset="1" stopColor="#D44102" />
        </linearGradient>
      </defs>
    </svg>
  ),
  bin: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="bevel"
        strokeWidth="2"
        d="m5 6 1 11h8l1-11M5 6H3m2 0h2m8 0h2m-2 0h-2M7 6V3h6v3M7 6h6"
      />
    </svg>
  ),
  done: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M5 9.76923L8.63636 13L15 7" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  uneditable: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C5 7.23858 7.23858 5 10 5C10.6789 5 11.3262 5.13531 11.9164 5.38042L13.411 3.88583C12.4017 3.3216 11.2384 3 10 3C6.13401 3 3 6.13401 3 10C3 11.2384 3.3216 12.4017 3.88583 13.411L5.38041 11.9164C5.1353 11.3262 5 10.6789 5 10ZM8.14881 14.6461L6.64811 16.1468C7.64356 16.6908 8.78567 17 10 17C13.866 17 17 13.866 17 10C17 8.78567 16.6908 7.64356 16.1468 6.64811L14.6461 8.14881C14.8744 8.72135 15 9.34602 15 10C15 12.7614 12.7614 15 10 15C9.34601 15 8.72135 14.8744 8.14881 14.6461ZM5.44028 15.3114L4.68863 14.5597C4.91986 14.8288 5.17118 15.0801 5.44028 15.3114Z"
        fill="currentColor"
      />
      <path
        d="M4.08594 15.957L10.0859 9.95703L16.0859 3.95703"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  info: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="6.1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM10 5.5C10.5523 5.5 11 5.94772 11 6.5V6.55C11 7.10228 10.5523 7.55 10 7.55C9.44772 7.55 9 7.10228 9 6.55V6.5C9 5.94772 9.44772 5.5 10 5.5ZM9 8.55078V13.5508H11V8.55078H9Z"
        fill="currentColor"
      />
    </svg>
  ),
  "checkbox-unselected": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2.5" y="2.5" width="15" height="15" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "checkbox-selected": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2.5" y="2.5" width="15" height="15" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M5 9.26923L8.63636 12.5L15 6.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "radio-unselected": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="2" width="16" height="16" rx="8" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "radio-selected": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="2" width="16" height="16" rx="8" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <circle cx="10" cy="10" r="4" fill="currentColor" />
    </svg>
  ),
  "radio-unselectable": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 10C3 6.13401 6.13401 3 10 3C11.162 3 12.2556 3.28239 13.2182 3.78178L14.6855 2.3145C14.6244 2.27717 14.5628 2.24055 14.5007 2.20465C13.1759 1.4383 11.6376 1 10 1C5.02944 1 1 5.02944 1 10C1 11.6376 1.4383 13.1759 2.20465 14.5007C2.24055 14.5628 2.27717 14.6244 2.3145 14.6855L3.78178 13.2182C3.28239 12.2556 3 11.162 3 10ZM6.78178 16.2182L5.3145 17.6855C5.37562 17.7228 5.43721 17.7594 5.49927 17.7953C6.82407 18.5617 8.36237 19 10 19C14.9706 19 19 14.9706 19 10C19 8.36237 18.5617 6.82407 17.7953 5.49927C17.7594 5.43721 17.7228 5.37562 17.6855 5.3145L16.2182 6.78178C16.7176 7.74443 17 8.83798 17 10C17 13.866 13.866 17 10 17C8.83798 17 7.74443 16.7176 6.78178 16.2182Z"
        fill="currentColor"
      />
      <path d="M16 4L4 16" stroke="currentColor" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
    </svg>
  ),
  show: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M19 10C19 10 13.866 16 10 16C6.13401 16 1 10 1 10C1 10 6.13401 4 10 4C13.866 4 19 10 19 10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <circle cx="10" cy="10" r="3.5" fill="currentColor" />
      <path d="M10 4L10 0.5" stroke="currentColor" strokeWidth="2" />
      <path d="M14.2109 5L15.4109 1.8" stroke="currentColor" strokeWidth="2" />
      <path d="M5.89062 5L4.69063 1.8" stroke="currentColor" strokeWidth="2" />
      <path d="M17 7L19 5" stroke="currentColor" strokeWidth="2" />
      <path d="M3 7L1 5" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  hide: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M19 8C19 8 13.866 12.5 10 12.5C6.13401 12.5 1 8 1 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path d="M10 13L10 16" stroke="currentColor" strokeWidth="2" />
      <path d="M5.78906 12L4.58906 15.2" stroke="currentColor" strokeWidth="2" />
      <path d="M14.1094 12L15.3094 15.2" stroke="currentColor" strokeWidth="2" />
      <path d="M3 10L1 12" stroke="currentColor" strokeWidth="2" />
      <path d="M17 10L19 12" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  "toggle-off": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="1" y="4" width="18" height="12" rx="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <rect x="1" y="4" width="12" height="12" rx="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "toggle-on": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="7" y="4" width="12" height="12" rx="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4C3.68629 4 1 6.68629 1 10C1 13.3137 3.68629 16 7 16H13C9.68629 16 7 13.3137 7 10C7 6.68629 9.68629 4 13 4H7Z"
        fill="currentColor"
      />
      <path
        d="M2 10C2 7.23858 4.23858 5 7 5V3C3.13401 3 0 6.13401 0 10H2ZM7 15C4.23858 15 2 12.7614 2 10H0C0 13.866 3.13401 17 7 17V15ZM13 15H7V17H13V15ZM13 15C10.2386 15 8 12.7614 8 10H6C6 13.866 9.13401 17 13 17V15ZM8 10C8 7.23858 10.2386 5 13 5V3C9.13401 3 6 6.13401 6 10H8ZM7 5H13V3H7V5Z"
        fill="currentColor"
      />
    </svg>
  ),
  geolocation: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M16 10C16 13.3137 13.3137 16 10 16M16 10C16 6.68629 13.3137 4 10 4M16 10H19M10 16C6.68629 16 4 13.3137 4 10M10 16V19M4 10C4 6.68629 6.68629 4 10 4M4 10H1M10 4V1M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  download: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M14 8L10 12M10 12L6 8M10 12L10 2" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M3 13V17H17V13" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  country: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M18 10H2m16 0a7.98 7.98 0 0 0-2.401-5.714A8 8 0 0 0 2 10m16 0a7.98 7.98 0 0 1-2.401 5.714A8 8 0 0 1 2 10"
      />
      <path stroke="currentColor" strokeWidth="2" d="M10 18s-3-2.857-3-8 3-8 3-8M10 18s3-2.857 3-8-3-8-3-8" />
    </svg>
  ),
  kisses: (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20">
      <path
        d="M12.84 4.899C12.172 4.359 11.519 4 10.963 4c-.173 0-.335.035-.48.104-.408.194-1.086 1.01-1.46 1.487h-.046c-.374-.477-1.052-1.293-1.46-1.487A1.111 1.111 0 0 0 7.037 4C5.02 4 1.72 8.728 1.079 9.675a.496.496 0 0 0-.029.486C4.446 16.922 8.774 17 8.957 17h.086c.183 0 4.51-.078 7.907-6.838a.496.496 0 0 0-.029-.487c-.113-.167-.31-.452-.567-.808m-7.482-.14c-1.645 0-2.878 1.132-2.93 1.18-.089.085-.142.232-.142.396s.053.312.142.395c.052.048 1.275 1.18 2.93 1.18h.256c1.655 0 2.878-1.132 2.93-1.18.089-.083.142-.231.142-.395s-.053-.311-.142-.395c-.052-.049-1.285-1.18-2.93-1.18h-.256Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M16.849 5.443a1.834 1.834 0 0 1 2.17 1.778 1.777 1.777 0 0 1-1.799 1.8l-4.429-.044-.044-4.43a1.777 1.777 0 0 1 1.799-1.799 1.834 1.834 0 0 1 1.778 2.17l-.123.649.648-.124Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "non-shoppable-country": (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.999 5.89h2.087c.36-2.068 1.812-3.888 3.913-3.888 1.613 0 2.845 1.074 3.492 2.509l-3.38 3.38H5.103l.45 4.557-1.828 1.83-.721-7.289.995-1.098ZM6 18.003h9l.994-.902.998-10.09-2.23 2.23-.669 6.762H8l-2 2Zm4-14c.704 0 1.566.668 1.878 1.889H8.12C8.432 4.67 9.294 4 10 4Z"
        clipRule="evenodd"
      />
      <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeWidth="2" d="m16 5.002-12 12" />
    </svg>
  ),
  visa: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
      <rect x=".5" y="4.5" width="23" height="15" rx=".5" fill="#fff" stroke="#EDEDED" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.589 15.193H6.135l-1.09-4.282c-.052-.197-.162-.371-.324-.453a4.641 4.641 0 0 0-1.332-.453V9.84H5.73c.323 0 .566.248.606.535l.566 3.089L8.356 9.84h1.413l-2.18 5.353Zm2.99 0H9.204l1.13-5.353h1.374l-1.13 5.353Zm2.905-3.87c.04-.288.283-.453.566-.453.444-.041.928.041 1.332.247l.243-1.153a3.389 3.389 0 0 0-1.252-.247c-1.333 0-2.303.741-2.303 1.77 0 .783.687 1.194 1.172 1.442.525.247.727.412.686.659 0 .37-.404.535-.807.535a3.38 3.38 0 0 1-1.414-.33l-.242 1.153c.485.206 1.01.289 1.494.289 1.495.04 2.423-.7 2.423-1.812 0-1.4-1.898-1.482-1.898-2.1Zm6.704 3.87-1.09-5.353h-1.172a.609.609 0 0 0-.565.412l-2.02 4.94h1.414l.283-.781h1.736l.162.782h1.252ZM18.13 11.28l.403 2.018h-1.13l.727-2.018Z"
        fill="#172B85"
      />
    </svg>
  ),
  postepay: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
      <rect x=".5" y="4.5" width="23" height="15" rx=".5" fill="#F5E11C" stroke="#EDEDED" />
      <path
        d="M4.539 10.66a.903.903 0 0 1 .34-.06c.225 0 .416.07.555.208.149.14.227.34.252.583.018.174 0 .365-.052.565-.043.2-.112.374-.208.522a1.065 1.065 0 0 1-.418.417c-.139.087-.295.13-.47.148v-.348c.062-.017.123-.043.175-.07A.838.838 0 0 0 5 12.314c.078-.14.139-.287.183-.452.043-.166.052-.322.043-.47a.638.638 0 0 0-.157-.374.484.484 0 0 0-.356-.139.557.557 0 0 0-.174.026v-.243ZM3 13.879l.6-2.635.052-.304.026-.304h.418l-.035.356c.13-.13.26-.235.391-.296.026-.017.061-.026.087-.034v.243c-.06.018-.122.052-.183.087a.878.878 0 0 0-.278.33 1.88 1.88 0 0 0-.182.487c-.044.192-.053.34-.044.461A.488.488 0 0 0 4 12.6c.087.079.2.122.339.122a.75.75 0 0 0 .2-.026v.348H4.46a.896.896 0 0 1-.417-.096.923.923 0 0 1-.304-.278l-.278 1.208H3ZM15.696 11.009c-.052 0-.096.009-.148.017v-.339c.026-.009.043-.017.061-.026a.903.903 0 0 1 .409-.087c.226 0 .409.07.539.2.13.13.209.322.226.574.043.47-.044.87-.27 1.191-.217.33-.513.496-.878.496-.026 0-.06-.009-.087-.009v-.452a.33.33 0 0 0 .148-.07.75.75 0 0 0 .2-.27c.06-.13.113-.277.148-.434.035-.156.043-.287.035-.4a.436.436 0 0 0-.113-.287.363.363 0 0 0-.27-.104Zm-.148.017c-.14.044-.261.157-.357.322-.139.235-.191.496-.165.783.018.148.053.26.13.339.07.078.166.122.287.122.035 0 .07-.01.105-.018v.452a.815.815 0 0 1-.34-.095.674.674 0 0 1-.286-.296l-.278 1.243h-.722l.556-2.52c.07-.323.113-.566.13-.723h.653l-.017.287c.104-.096.2-.174.304-.235v.34ZM18.407 11.87c-.017-.01-.034-.01-.052-.01h-.078a1.09 1.09 0 0 0-.304.035v-.382c.095-.009.209-.009.322-.009h.2c.017-.087.034-.148.034-.2.01-.043.01-.078.01-.113-.01-.07-.036-.122-.088-.156-.044-.035-.113-.053-.2-.053a.36.36 0 0 0-.235.07c-.017.017-.034.026-.043.052v-.487c.087-.017.183-.017.278-.017.304 0 .53.043.696.148a.572.572 0 0 1 .26.452.689.689 0 0 1 0 .191c-.008.061-.025.14-.043.218l-.183.8c-.026.095-.034.19-.052.295-.008.104-.008.2-.008.305h-.661v-.166c0-.06.008-.113.008-.174a.853.853 0 0 1-.295.27v-.365a.692.692 0 0 0 .209-.166c.113-.139.19-.321.226-.539Zm-.434.025a.703.703 0 0 0-.243.113c-.149.096-.209.218-.192.357 0 .078.026.14.078.183.044.043.105.06.183.06a.39.39 0 0 0 .174-.034v.365l-.018.009a.776.776 0 0 1-.382.095.74.74 0 0 1-.504-.173.642.642 0 0 1-.218-.453.682.682 0 0 1 .33-.678c.192-.122.453-.2.792-.226v.382Zm0-1.278v.487a.457.457 0 0 0-.07.174h-.686a.655.655 0 0 1 .295-.504c.13-.079.278-.13.46-.157ZM19.33 13.87l.574-.87-.418-2.383h.714l.2 1.635.921-1.635H22l-1.479 2.478-.426.774h-.765ZM7.052 10.861a.602.602 0 0 0-.174.026v-.304c.07-.009.148-.009.226-.009.278 0 .496.07.661.2.174.14.26.33.287.574.017.191 0 .4-.061.617a1.75 1.75 0 0 1-.235.566c-.122.182-.261.313-.435.39-.122.062-.27.097-.443.114v-.304a.64.64 0 0 0 .19-.078.783.783 0 0 0 .27-.287c.087-.148.149-.313.192-.496.043-.191.06-.347.052-.487-.018-.182-.07-.313-.156-.391-.088-.087-.209-.13-.374-.13Zm-.174.026a.898.898 0 0 0-.192.079 1.02 1.02 0 0 0-.278.322c-.078.13-.14.286-.182.478-.044.191-.053.356-.044.495.009.157.07.27.156.357a.53.53 0 0 0 .374.13c.061 0 .113-.008.166-.017v.304c-.062 0-.131.01-.2.01-.279 0-.505-.07-.67-.218-.174-.14-.27-.34-.287-.592-.017-.208 0-.417.07-.643.06-.226.147-.417.27-.583.112-.147.251-.252.425-.33.113-.043.253-.078.392-.095v.303ZM8.531 12.227a.3.3 0 0 0-.026.112.15.15 0 0 0 0 .088c.009.095.043.165.113.208.07.052.165.07.304.07.183 0 .322-.035.426-.105.105-.078.148-.174.14-.286 0-.07-.035-.131-.097-.183a1.736 1.736 0 0 0-.373-.209c-.244-.113-.417-.217-.513-.313a.452.452 0 0 1-.165-.322.573.573 0 0 1 .226-.513c.174-.13.409-.2.704-.2.27 0 .47.044.6.122.14.078.209.191.226.357v.087c0 .025 0 .069-.008.13H9.66v-.13c-.008-.088-.043-.157-.112-.2a.496.496 0 0 0-.287-.07.543.543 0 0 0-.34.096.263.263 0 0 0-.113.252.235.235 0 0 0 .096.165c.052.052.183.122.383.217.278.13.47.244.548.331.078.087.13.2.139.33.017.218-.07.409-.278.557-.2.147-.47.226-.8.226-.261 0-.461-.053-.618-.14a.508.508 0 0 1-.243-.4.334.334 0 0 1 0-.13c.009-.044.017-.096.026-.148h.47ZM11.39 13.009c-.086.009-.164.017-.234.026-.07 0-.14.008-.2.008-.174 0-.304-.025-.383-.086-.086-.053-.13-.148-.139-.279-.008-.043 0-.122.01-.217.008-.104.034-.209.051-.322l.27-1.182h-.435l.078-.305h.426l.122-.539.46-.113-.138.652h.513l-.07.305h-.513l-.26 1.235a.973.973 0 0 0-.044.208c-.009.052-.017.087-.009.113 0 .07.026.113.07.14.043.034.122.052.226.052a.98.98 0 0 0 .14-.018c.042 0 .095-.018.138-.026l-.078.348ZM12.896 11.549h.591c.01-.079.018-.14.018-.183a.242.242 0 0 0 0-.113.392.392 0 0 0-.148-.295.615.615 0 0 0-.374-.113c-.026 0-.06.008-.087.008v-.286h.096c.304 0 .539.06.696.173.147.114.243.296.26.548.01.087.01.183 0 .279 0 .095-.017.2-.043.304h-1.009v-.322Zm0 1.478v-.356a.754.754 0 0 0 .148-.07.578.578 0 0 0 .226-.304h.513a.902.902 0 0 1-.391.548c-.14.095-.305.156-.496.182Zm-.609-1.478h.61v.322h-.688a.828.828 0 0 0-.043.2c-.009.06-.009.121-.009.174.018.148.07.26.157.339a.576.576 0 0 0 .382.121c.07 0 .139-.008.2-.035v.357a2.297 2.297 0 0 1-.252.017c-.278 0-.496-.069-.661-.2a.781.781 0 0 1-.27-.565c-.017-.182 0-.39.062-.626.052-.226.139-.426.234-.591.105-.156.244-.287.409-.365.14-.079.296-.113.478-.13v.286a.558.558 0 0 0-.356.174c-.122.113-.209.287-.252.522Z"
        fill="#0356A2"
      />
    </svg>
  ),
  mastercard: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
      <rect x=".5" y="4.5" width="23" height="15" rx=".5" fill="#fff" stroke="#EDEDED" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.125 15.88a4.801 4.801 0 0 1-3.104 1.13c-2.644 0-4.787-2.118-4.787-4.73 0-2.612 2.143-4.73 4.787-4.73 1.184 0 2.268.426 3.104 1.13a4.802 4.802 0 0 1 3.105-1.13c2.643 0 4.786 2.118 4.786 4.73 0 2.612-2.143 4.73-4.786 4.73a4.802 4.802 0 0 1-3.105-1.13Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.125 15.88a4.696 4.696 0 0 0 1.682-3.6 4.696 4.696 0 0 0-1.682-3.6 4.801 4.801 0 0 1 3.105-1.13c2.643 0 4.786 2.118 4.786 4.73 0 2.612-2.143 4.73-4.786 4.73a4.802 4.802 0 0 1-3.105-1.13Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.125 15.878a4.696 4.696 0 0 0 1.682-3.6 4.696 4.696 0 0 0-1.682-3.6 4.696 4.696 0 0 0-1.682 3.6c0 1.442.653 2.733 1.682 3.6Z"
        fill="#FF5E00"
      />
    </svg>
  ),
  maestro: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
      <rect x=".5" y="4.5" width="23" height="15" rx=".5" fill="#fff" stroke="#EDEDED" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.125 15.88a4.801 4.801 0 0 1-3.104 1.13c-2.644 0-4.787-2.118-4.787-4.73 0-2.612 2.143-4.73 4.787-4.73 1.184 0 2.268.426 3.104 1.13a4.802 4.802 0 0 1 3.105-1.13c2.643 0 4.786 2.118 4.786 4.73 0 2.612-2.143 4.73-4.786 4.73a4.802 4.802 0 0 1-3.105-1.13Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.125 15.88a4.696 4.696 0 0 0 1.682-3.6 4.696 4.696 0 0 0-1.682-3.6 4.801 4.801 0 0 1 3.105-1.13c2.643 0 4.786 2.118 4.786 4.73 0 2.612-2.143 4.73-4.786 4.73a4.802 4.802 0 0 1-3.105-1.13Z"
        fill="#00A2E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.125 15.878a4.696 4.696 0 0 0 1.682-3.6 4.696 4.696 0 0 0-1.682-3.6 4.696 4.696 0 0 0-1.682 3.6c0 1.442.653 2.733 1.682 3.6Z"
        fill="#7375CF"
      />
    </svg>
  ),
  amex: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
      <rect y="4" width="24" height="16" rx="1" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m4.302 10-2.245 5.115h2.688l.333-.815h.762l.333.815h2.959v-.622l.264.622h1.53l.264-.635v.635h6.154l.748-.794.7.794 3.161.007-2.252-2.55L21.953 10h-3.111l-.729.78-.678-.78H10.74l-.575 1.32L9.577 10H6.894v.601L6.596 10H4.302Zm.52.727h1.311l1.49 3.468v-3.468h1.435l1.15 2.487 1.06-2.487h1.429v3.67h-.87l-.006-2.876-1.267 2.876h-.778l-1.274-2.876v2.876H6.714l-.339-.823h-1.83l-.339.822h-.958l1.575-3.67Zm12.204 0h-3.534v3.668h3.48l1.12-1.216 1.081 1.216h1.13l-1.642-1.824 1.642-1.844h-1.08l-1.116 1.201-1.081-1.201Zm-11.567.62-.604 1.467h1.206l-.602-1.466Zm8.904.81v-.67h2.205l.962 1.07-1.004 1.078h-2.163v-.731h1.928v-.747h-1.928Z"
        fill="#fff"
      />
    </svg>
  ),
  paypal: (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
      <rect x="0.5" y="3.5" width="25" height="17" rx="1.5" fill="white" stroke="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3174 17.0216L11.4732 15.9987L11.1261 15.9904H9.46875L10.6206 8.44192C10.6241 8.41906 10.6357 8.39784 10.6527 8.38275C10.6697 8.36766 10.6914 8.35938 10.7141 8.35938H13.5087C14.4365 8.35938 15.0768 8.55888 15.411 8.95272C15.5677 9.13748 15.6675 9.33061 15.7158 9.54305C15.7665 9.76602 15.7673 10.0324 15.7179 10.3573L15.7143 10.3809V10.5892L15.8711 10.6809C16.003 10.7533 16.1079 10.8361 16.1883 10.9309C16.3224 11.0889 16.4091 11.2897 16.4457 11.5277C16.4836 11.7725 16.4711 12.0639 16.4091 12.3937C16.3376 12.773 16.222 13.1035 16.0658 13.3738C15.9223 13.6229 15.7394 13.8296 15.5221 13.9897C15.3148 14.1418 15.0684 14.2573 14.7898 14.3312C14.5199 14.4039 14.2121 14.4405 13.8745 14.4405H13.6571C13.5016 14.4405 13.3505 14.4984 13.232 14.6022C13.113 14.7081 13.0344 14.8528 13.0103 15.0111L12.9939 15.1032L12.7186 16.9062L12.7061 16.9724C12.7028 16.9933 12.6971 17.0038 12.6888 17.0108C12.6813 17.0173 12.6707 17.0216 12.6602 17.0216H11.3174Z"
        fill="#28356A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0191 10.4062C16.0108 10.4614 16.0012 10.5177 15.9906 10.5756C15.622 12.5313 14.3611 13.207 12.7508 13.207H11.9309C11.734 13.207 11.568 13.3547 11.5374 13.5555L10.9987 17.0872C10.9787 17.2191 11.077 17.3379 11.2057 17.3379H12.66C12.8321 17.3379 12.9784 17.2086 13.0055 17.0331L13.0198 16.9567L13.2936 15.1608L13.3112 15.0623C13.338 14.8862 13.4846 14.7568 13.6568 14.7568H13.8743C15.2832 14.7568 16.3862 14.1656 16.7086 12.4546C16.8432 11.7399 16.7735 11.1431 16.4172 10.7234C16.3093 10.5969 16.1756 10.4918 16.0191 10.4062Z"
        fill="#298FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6334 10.2461C15.577 10.2291 15.519 10.2137 15.4594 10.1999C15.3995 10.1863 15.3381 10.1743 15.2749 10.1638C15.0539 10.1269 14.8116 10.1094 14.5522 10.1094H12.3618C12.3078 10.1094 12.2566 10.122 12.2107 10.1447C12.1097 10.1949 12.0347 10.2938 12.0165 10.4148L11.5505 13.4653L11.5371 13.5542C11.5677 13.3534 11.7337 13.2057 11.9307 13.2057H12.7506C14.3609 13.2057 15.6218 12.5297 15.9903 10.5743C16.0013 10.5164 16.0106 10.4601 16.0188 10.405C15.9256 10.3538 15.8246 10.3101 15.7159 10.2728C15.689 10.2636 15.6613 10.2547 15.6334 10.2461Z"
        fill="#22284F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0167 10.4157C12.0349 10.2947 12.1099 10.1959 12.2109 10.146C12.2571 10.1232 12.308 10.1106 12.362 10.1106H14.5524C14.8118 10.1106 15.0541 10.1282 15.2751 10.1651C15.3383 10.1755 15.3997 10.1876 15.4596 10.2011C15.5192 10.2149 15.5772 10.2304 15.6336 10.2473C15.6615 10.2559 15.6892 10.2649 15.7164 10.2738C15.8251 10.311 15.9262 10.3551 16.0194 10.4059C16.129 9.68316 16.0185 9.19108 15.6404 8.74549C15.2236 8.25487 14.4713 8.04492 13.5087 8.04492H10.714C10.5174 8.04492 10.3497 8.19268 10.3193 8.39382L9.15532 16.0199C9.13237 16.1708 9.24495 16.3069 9.39216 16.3069H11.1175L12.0167 10.4157Z"
        fill="#28356A"
      />
    </svg>
  ),
  klarna: (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
      <rect x="0.5" y="3.5" width="25" height="17" rx="1.5" fill="white" stroke="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.71876 14.5033H3.74219V10H4.71876V14.5033ZM7.15757 10H6.20218C6.20218 10.8287 5.84215 11.5893 5.21445 12.087L4.83594 12.387L6.30254 14.5034H7.50837L6.1589 12.556C6.79857 11.8818 7.15757 10.9749 7.15757 10ZM8.71522 14.5012H7.79297V10H8.71522V14.5012ZM11.5018 11.3888V11.588C11.2529 11.4083 10.9526 11.3027 10.6286 11.3027C9.77122 11.3027 9.07617 12.0383 9.07617 12.9457C9.07617 13.8531 9.77122 14.5886 10.6286 14.5886C10.9526 14.5886 11.2529 14.4831 11.5018 14.3034V14.5024H12.3827V11.3888H11.5018ZM11.4987 12.9456C11.4987 13.388 11.1413 13.7467 10.7005 13.7467C10.2597 13.7467 9.90234 13.388 9.90234 12.9456C9.90234 12.5031 10.2597 12.1445 10.7005 12.1445C11.1413 12.1445 11.4987 12.5031 11.4987 12.9456ZM20.7948 11.588V11.3888H21.6756V14.5024H20.7948V14.3034C20.5459 14.4831 20.2456 14.5886 19.9216 14.5886C19.0642 14.5886 18.3691 13.8531 18.3691 12.9457C18.3691 12.0383 19.0642 11.3027 19.9216 11.3027C20.2456 11.3027 20.5459 11.4083 20.7948 11.588ZM19.9935 13.7467C20.4343 13.7467 20.7916 13.388 20.7916 12.9456C20.7916 12.5031 20.4343 12.1445 19.9935 12.1445C19.5526 12.1445 19.1953 12.5031 19.1953 12.9456C19.1953 13.388 19.5526 13.7467 19.9935 13.7467ZM22.0586 13.9835C22.0586 13.6603 22.3061 13.3984 22.6113 13.3984C22.9166 13.3984 23.1641 13.6603 23.1641 13.9835C23.1641 14.3065 22.9166 14.5684 22.6113 14.5684C22.3061 14.5684 22.0586 14.3065 22.0586 13.9835ZM16.8041 11.3047C16.4523 11.3047 16.1192 11.4203 15.8966 11.7393V11.3886H15.0195V14.5021H15.9074V12.8658C15.9074 12.3924 16.2074 12.1605 16.5686 12.1605C16.9557 12.1605 17.1783 12.4053 17.1783 12.8594V14.5021H18.0581V12.522C18.0581 11.7975 17.5138 11.3047 16.8041 11.3047ZM13.7456 11.3887V11.7942C13.9222 11.5509 14.2512 11.3889 14.6089 11.3889V12.2949L14.6046 12.2947L14.5984 12.2945C14.2499 12.2945 13.7476 12.5581 13.7476 13.0486V14.5023H12.8438V11.3887H13.7456Z"
        fill="currentColor"
      />
    </svg>
  ),
  alipay: (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
      <path
        d="M2 3.5C1.17157 3.5 0.5 4.17157 0.5 5V19C0.5 19.8284 1.17157 20.5 2 20.5H24C24.8284 20.5 25.5 19.8284 25.5 19V5C25.5 4.17157 24.8284 3.5 24 3.5H2Z"
        fill="white"
        stroke="white"
      />
      <path
        d="M16.3766 6.88867H9.48865C8.59165 6.88867 7.86523 7.62149 7.86523 8.52606V15.4723C7.86523 16.3763 8.59165 17.1094 9.48865 17.1094H16.3766C17.2734 17.1094 17.9994 16.3763 17.9994 15.4723V8.52606C17.9994 7.62149 17.2734 6.88867 16.3766 6.88867Z"
        fill="#1677FF"
      />
      <path
        d="M10.6037 14.7485C9.02708 14.7485 8.56096 13.496 9.34012 12.8108C9.60013 12.5792 10.0752 12.4662 10.3285 12.4408C11.2651 12.3474 12.132 12.7078 13.1551 13.2114C12.436 14.1575 11.52 14.7485 10.6037 14.7485ZM16.2092 13.3064C15.8036 13.1694 15.2595 12.9599 14.6534 12.7388C15.0174 12.1007 15.3081 11.374 15.4992 10.5842H13.5016V9.85852H15.9487V9.45348H13.5016V8.24381H12.5029C12.3277 8.24381 12.3277 8.41823 12.3277 8.41823V9.45348H9.85276V9.85852H12.3277V10.5842H10.2843V10.9891H14.2474C14.1024 11.493 13.9077 11.9661 13.6766 12.396C12.3906 11.9681 11.0184 11.6212 10.1563 11.8347C9.60501 11.9717 9.24994 12.2162 9.04134 12.4724C8.08393 13.6472 8.77061 15.4316 10.7926 15.4316C11.9881 15.4316 13.1397 14.7594 14.0323 13.6516C15.3637 14.297 17.9995 15.4052 17.9995 15.4052V13.8258C17.9995 13.8258 17.6685 13.7992 16.2092 13.3064Z"
        fill="white"
      />
    </svg>
  ),
  "cash-on-delivery": (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
      <rect x="0.5" y="3.5" width="25" height="17" rx="1.5" fill="white" stroke="white" />
      <rect x="5" y="7" width="14" height="8" rx="1" stroke="currentColor" strokeMiterlimit="10" />
      <path
        d="M20 8.5V8.5C20.2761 8.5 20.5 8.72386 20.5 9V15.5C20.5 16.0523 20.0523 16.5 19.5 16.5H7C6.72386 16.5 6.5 16.2761 6.5 16V16"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M12.3618 13.071C12.0698 13.071 11.7998 13.015 11.5518 12.903C11.3038 12.791 11.0878 12.633 10.9038 12.429C10.7238 12.221 10.5838 11.977 10.4838 11.697C10.3838 11.413 10.3338 11.101 10.3338 10.761C10.3338 10.421 10.3818 10.111 10.4778 9.83103C10.5778 9.55103 10.7178 9.30903 10.8978 9.10503C11.0818 8.89703 11.2978 8.73703 11.5458 8.62503C11.7938 8.51303 12.0678 8.45703 12.3678 8.45703C12.7718 8.45703 13.1278 8.56303 13.4358 8.77503C13.7438 8.98303 13.9578 9.26903 14.0778 9.63303L13.3398 9.91503C13.2598 9.68703 13.1338 9.50903 12.9618 9.38103C12.7898 9.25303 12.5898 9.18903 12.3618 9.18903C12.1298 9.18903 11.9218 9.25703 11.7378 9.39303C11.5538 9.52903 11.4098 9.71503 11.3058 9.95103C11.2018 10.183 11.1498 10.453 11.1498 10.761C11.1498 11.069 11.1998 11.343 11.2998 11.583C11.4038 11.819 11.5458 12.003 11.7258 12.135C11.9098 12.267 12.1218 12.333 12.3618 12.333C12.5898 12.333 12.7898 12.269 12.9618 12.141C13.1338 12.013 13.2598 11.837 13.3398 11.613L14.0778 11.895C13.9978 12.139 13.8738 12.349 13.7058 12.525C13.5418 12.697 13.3438 12.831 13.1118 12.927C12.8838 13.023 12.6338 13.071 12.3618 13.071ZM9.8418 11.445V10.941H12.5118V11.445H9.8418ZM9.8418 10.581V10.077H12.5118V10.581H9.8418Z"
        fill="currentColor"
      />
    </svg>
  ),
  "non-transfer": (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.4206 29.265C46.9262 27.223 48.4239 24.8276 49.8655 22.0178C50.07 21.6228 50.039 21.115 49.7881 20.7542C48.0688 18.2904 39.2198 6 33.8159 6C33.3513 6 32.9183 6.09089 32.5279 6.27045C31.4059 6.79298 28.9644 8.99943 27.9363 10.2835C26.9082 8.99886 25.0439 6.80262 23.9224 6.28009C23.5219 6.09412 23.0778 6 22.6012 6C17.0581 6 7.98097 18.7285 6.21734 21.2801C5.96004 21.6537 5.92816 22.1797 6.13792 22.5887C15.4768 40.7912 27.3798 41 27.882 41H27.9648C28.5054 41 31.6951 40.6372 35 39M35.2965 24.0431C35.549 23.8202 35.7 23.4179 35.7 22.9691C35.7 22.5197 35.549 22.118 35.2971 21.895C32.9222 19.7935 30.3487 18.7273 27.649 18.7273C23.1252 18.7273 19.7341 21.7748 19.5912 21.9053C19.3461 22.1312 19.2 22.5287 19.2 22.9691C19.2 23.4113 19.3461 23.8088 19.5912 24.0329C19.7323 24.1627 23.0955 27.2121 27.6484 27.2121C30.3481 27.2121 32.921 26.1459 35.2965 24.0431Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M35 50V33.5031C35 30.5633 36.3468 28.3576 38.536 27.4359M47 50V33.5031C47 30.7152 45.6623 28.4445 43.4863 27.4727M38 38.0812V28C38 26.3431 39.3431 25 41 25V25C42.6569 25 44 26.3437 44 28.0006C44 31.4296 44 34.0602 44 38.0812H38Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  "made-in-FR": (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        d="M27.0001 9.82416V6H29.0001V9.82416H30.2675L31.2675 10.8242C31.2675 14.2955 31.3546 19.2004 31.8296 24.0424C31.9621 25.3936 32.1241 26.7305 32.3208 28.0233H34.2791V30.0233H32.6608C33.0331 31.9885 33.4996 33.8034 34.0814 35.3488H37.4187V37.3488H34.97C37.629 42.7189 40.9463 47.3258 42.1187 48.9539L42.1191 48.9544C42.2467 49.1316 42.3489 49.2735 42.422 49.3773L41.6047 50.9535H34.2355L33.2355 49.9535C33.2355 49.1426 32.9696 47.8943 32.1928 46.8742C31.4522 45.9014 30.1913 45.0573 28.0001 45.0573C25.8089 45.0573 24.548 45.9014 23.8073 46.8742C23.0305 47.8943 22.7646 49.1426 22.7646 49.9535L21.7646 50.9535H14.3954L13.5781 49.3773C13.6512 49.2736 13.7532 49.1319 13.8807 48.9549L13.8809 48.9546L13.8814 48.9539L13.8814 48.9539C15.0539 47.3257 18.3712 42.7189 21.0301 37.3488H18.5815V35.3488H21.9188C22.5005 33.8034 22.9671 31.9885 23.3394 30.0233H21.721V28.0233H23.6794C23.876 26.7305 24.038 25.3936 24.1705 24.0424C24.6455 19.2004 24.7326 14.2955 24.7326 10.8242L25.7326 9.82416H27.0001ZM23.2511 37.3488C23.2164 37.4241 23.1814 37.4986 23.1459 37.5725C20.842 42.3771 17.9553 46.6627 16.3397 48.9535H20.8443C21.0012 47.9304 21.4075 46.7246 22.2161 45.6626C23.3461 44.1785 25.2029 43.0573 28.0001 43.0573C30.7972 43.0573 32.6541 44.1785 33.7841 45.6626C34.5927 46.7246 34.999 47.9304 35.1559 48.9535H39.6605C38.0448 46.6627 35.1581 42.377 32.8542 37.5725C32.8188 37.4986 32.7837 37.4241 32.749 37.3488H23.2511ZM31.9578 35.3488H24.0424C24.5914 33.7371 25.0272 31.9263 25.3738 30.0233H30.6264C30.973 31.9263 31.4088 33.7371 31.9578 35.3488ZM29.8392 24.2377C29.9633 25.5035 30.1143 26.7746 30.2982 28.0233H25.7019C25.8859 26.7746 26.0368 25.5035 26.161 24.2377C26.6008 19.7541 26.7132 15.2355 26.7302 11.8242H28.0001H29.27C29.2869 15.2355 29.3993 19.7541 29.8392 24.2377Z"
        fill="currentColor"
      />
    </svg>
  ),
  "made-in-US": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        d="M20.2268 42.3954C20.2268 42.3954 24.0622 42.1819 28.2654 38.7192C32.4686 35.2565 33.6474 31.1372 33.6474 31.1372C34.5808 32.6243 35.7517 36.2466 34.4693 38.0202"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path d="M20.7744 48.7473H38.0871" stroke="currentColor" strokeWidth="2" />
      <path d="M31.4819 31.5551L31.4819 27.7627" stroke="currentColor" strokeWidth="2" />
      <path
        d="M19.2578 22.2435L18.2529 13.8893H21.2675L20.2626 22.2435H19.2578Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M20.7696 21.2567L22.5943 28.0388L19.7983 29.4656L18.3498 22.7023L19.0159 20.3239L20.7696 21.2567Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M19.6786 12.8353H19.6469C18.6923 12.7622 18.0647 12.3357 17.8115 11.5925C17.2208 9.99634 18.9297 7.54729 19.2778 7.07819C19.3273 7.01026 19.389 6.95566 19.4587 6.9182C19.5284 6.88074 19.6044 6.86133 19.6812 6.86133C19.7581 6.86133 19.834 6.88074 19.9037 6.9182C19.9734 6.95566 20.0352 7.01026 20.0847 7.07819C20.4328 7.54729 22.1416 9.99634 21.5509 11.6169C21.2872 12.3357 20.6701 12.7378 19.7155 12.8353H19.6786Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M25.248 25.3362C25.248 27.2605 26.808 28.8204 28.7323 28.8204V28.8204C30.6565 28.8204 32.2165 27.2605 32.2165 25.3362V22.5736H28.7323H25.248V25.3362Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M32.2158 22.5739C32.2158 22.5739 31.5886 19.8167 28.7316 19.8167C25.8747 19.8167 25.2474 22.5739 25.2474 22.5739"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M24.8979 23.6604L20.4229 21.1096L25.3174 20.8874L23.4759 15.6725L27.4907 19.5202L28.7035 13.9999L29.8745 19.5202L34.0984 16.0912L32.0073 21.1096H37.3399L32.4256 23.6604"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <rect
        x="34.8882"
        y="37.2787"
        width="6.60035"
        height="8.66449"
        transform="rotate(29.1666 34.8882 37.2787)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M18.2535 30.5755L17.7535 29.7095L17.4035 31.1023L18.2535 30.5755ZM23.9696 27.2753L24.7772 26.6857L23.4696 26.4093L23.9696 27.2753ZM27.0123 31.4431L26.2047 32.0328L27.0123 32.4431L27.0123 31.4431ZM19.0141 48.644L18.025 48.4971L18.8569 49.6315L19.0141 48.644ZM34.5354 31.4431L35.1868 30.6844L34.5354 30.4431L34.5354 31.4431ZM21.0314 35.0577L22.0206 35.2046L21.8814 34.5309L21.0314 35.0577ZM31.7218 44.5826L32.3612 43.8138L30.8235 42.535L30.1841 43.3039L31.7218 44.5826ZM18.7535 31.4415L24.4696 28.1414L23.4696 26.4093L17.7535 29.7095L18.7535 31.4415ZM23.1619 27.865L26.2047 32.0328L27.82 30.8535L24.7772 26.6857L23.1619 27.865ZM27.0123 32.4431L34.5354 32.4431L34.5354 30.4431L27.0123 30.4431L27.0123 32.4431ZM20.0033 48.7909L22.0206 35.2046L20.0423 34.9108L18.025 48.4971L20.0033 48.7909ZM21.8814 34.5309L19.1035 30.0487L17.4035 31.1023L20.1815 35.5845L21.8814 34.5309ZM33.8841 32.2019C34.93 33.0999 35.881 33.8964 36.5035 34.927C37.0876 35.8942 37.4036 37.1156 36.9934 38.9063L38.9429 39.3529C39.4655 37.0717 39.0757 35.3174 38.2155 33.8931C37.3937 32.5323 36.1619 31.5215 35.1868 30.6844L33.8841 32.2019ZM18.8569 49.6315C20.6004 49.9091 23.0247 49.5737 25.355 48.7473C27.6965 47.9169 30.0965 46.5372 31.7218 44.5826L30.1841 43.3039C28.8617 44.894 26.8158 46.1072 24.6865 46.8623C22.5461 47.6214 20.4748 47.8639 19.1714 47.6564L18.8569 49.6315Z"
        fill="currentColor"
      />
    </svg>
  ),
  "made-in-DE": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <rect
        x="22.1533"
        y="15.1647"
        width="11.6559"
        height="6.86377"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <rect
        x="9.47461"
        y="18.6838"
        width="37.0128"
        height="3.34462"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <rect
        x="8.57373"
        y="22.0284"
        width="38.853"
        height="4.78264"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.63086 45.6855H49.3691"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.63086 26.8112H49.3691"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.63086 22.0284H49.3691"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M8.57373 18.6838H47.4267"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M20.7148 15.1647H35.2847"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M28 15.1647L28 10.3081"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path d="M25.7974 15.0813L24.4011 11.2434" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M22.9102 15.0813L21.8383 12.2072" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M30.2026 14.9978L31.5041 11.2434" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M33.0898 14.9978L34.1883 12.2071" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <rect
        x="8.57275"
        y="26.811"
        width="4.47151"
        height="18.7189"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <rect
        x="16.9297"
        y="26.811"
        width="4.47151"
        height="18.7189"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <rect
        x="34.5977"
        y="26.811"
        width="4.47151"
        height="18.7189"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <rect
        x="42.9541"
        y="26.811"
        width="4.47151"
        height="18.7189"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "made-in-PL": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 11.0837V8.97034C29 8.41805 28.5523 7.97034 28 7.97034C27.4477 7.97034 27 8.41805 27 8.97034V11.1715C26.9748 11.1973 26.9485 11.2244 26.9213 11.2526C26.672 11.5115 26.3368 11.875 25.999 12.2898C25.6641 12.7009 25.3092 13.1834 25.0333 13.6791C24.7711 14.1502 24.5129 14.7501 24.5129 15.3669C24.5129 16.0375 24.8195 16.7043 25.1171 17.2188C25.2781 17.4971 25.4612 17.7718 25.6498 18.0323C25.3274 18.3661 24.9171 18.789 24.5145 19.2036C24.1361 19.5933 23.7687 19.9711 23.4958 20.2515L23.1681 20.5883L23.077 20.6819L23.0531 20.7064L23.047 20.7127L23.0455 20.7142L23.0451 20.7146L23.045 20.7147L23.0763 20.7452L23.0763 20.7453L23.045 20.7148L23.0633 20.7582L22.6155 21.2061V31.0764H13.9681L13.9679 30.3108L13.6796 29.6087L12.2242 28.134V25.9354C12.2242 25.3832 11.7764 24.9354 11.2242 24.9354C10.6719 24.9354 10.2242 25.3832 10.2242 25.9354V28.134L8.76873 29.6087L8.48047 30.3112V36.4966L8.48132 36.4969V47.0293L9.48132 48.0293H23.6153L23.6155 48.0295H26.1223L26.1225 48.0297H29.8872L29.8874 48.0295H32.3958L32.396 48.0293H46.5196L47.5196 47.0293V36.4287L47.5176 36.4268V30.3112L47.2294 29.6087L45.7739 28.134V25.9354C45.7739 25.3832 45.3262 24.9354 44.7739 24.9354C44.2217 24.9354 43.7739 25.3832 43.7739 25.9354V28.134L42.3185 29.6087L42.0303 30.3108L42.03 31.0764H33.3958V21.2061L32.9639 20.7741L32.9798 20.7379L32.9526 20.7628L32.9525 20.7628L32.9798 20.7379L32.9797 20.7378L32.9793 20.7374L32.9779 20.7358L32.9723 20.7297L32.9506 20.706L32.8681 20.6158L32.57 20.2902C32.3211 20.0187 31.9838 19.6513 31.6305 19.268C31.2493 18.8545 30.8397 18.4119 30.5018 18.0514C30.7008 17.7919 30.894 17.5182 31.0641 17.2408C31.3781 16.7287 31.7095 16.0533 31.7095 15.3669C31.7095 14.735 31.43 14.1268 31.153 13.6573C30.8602 13.1609 30.4839 12.6784 30.1296 12.2679C29.7718 11.8535 29.417 11.4904 29.1532 11.232C29.0982 11.1781 29.0468 11.1285 29 11.0837ZM29.7744 20.2061C29.193 19.5776 28.6557 19.0026 28.4642 18.8138L28.4134 17.4439C28.7601 17.0471 29.1057 16.6086 29.3591 16.1954C29.6343 15.7465 29.7095 15.4719 29.7095 15.3669C29.7095 15.2812 29.6548 15.0538 29.4305 14.6735C29.222 14.3202 28.9298 13.9387 28.6157 13.5749C28.4244 13.3533 28.2319 13.1462 28.0569 12.9656C27.8971 13.1409 27.7229 13.3402 27.5496 13.5529C27.2538 13.9162 26.978 14.2976 26.7808 14.6518C26.5701 15.0304 26.5129 15.2662 26.5129 15.3669C26.5129 15.4878 26.5901 15.7709 26.8483 16.2173C27.0877 16.6311 27.4138 17.0695 27.7404 17.4657L27.7009 18.783C27.5451 18.9504 26.9555 19.56 26.3287 20.2061H29.7744ZM24.6155 22.4124H31.3958V32.0651L31.3845 32.0764V36.4951L31.3854 36.496V46.0295H30.8872V44.0655C30.8872 42.4737 29.5967 41.1832 28.0048 41.1832C26.4129 41.1832 25.1225 42.4737 25.1225 44.0655V46.0295H24.6155V36.4951V36.4287V32.0764V22.4124ZM33.3958 33.0764V35.4287H44.036L42.3222 33.7145L42.3201 33.7093L41.6874 33.0764H33.3958ZM33.3958 37.4951V46.0293H45.5196V37.4951H33.3958ZM28.8872 44.0655V46.0295H27.1225V44.0655C27.1225 43.5782 27.5175 43.1832 28.0048 43.1832C28.4922 43.1832 28.8872 43.5782 28.8872 44.0655ZM22.6155 37.4951V46.0293H10.4813V37.4951H22.6155ZM22.6155 33.0764V35.4287H11.9621L13.6759 33.7145L13.6767 33.7125L14.3126 33.0764H22.6155ZM11.9686 32.5924L10.4805 34.081L10.4805 30.7215L11.2242 29.968L11.968 30.7217L11.9686 32.5924ZM45.5176 34.0791L44.0295 32.5905L44.0301 30.7217L44.7739 29.968L45.5176 30.7215V34.0791ZM29.3226 35.0517L30.3226 36.0517V39.5835L29.3226 40.5835H26.6759L25.6759 39.5835V36.0517L26.6759 35.0517H29.3226ZM28.3226 38.5835V37.0517H27.6759V38.5835H28.3226ZM30.3226 29.869L29.3226 28.869H26.6759L25.6759 29.869V33.4008L26.6759 34.4008H29.3226L30.3226 33.4008V29.869ZM28.3226 30.869V32.4008H27.6759V30.869H28.3226ZM28.0055 25.1278C27.704 25.1278 27.4595 25.3722 27.4595 25.6737C27.4595 25.9752 27.704 26.2197 28.0055 26.2197C28.307 26.2197 28.5514 25.9752 28.5514 25.6737C28.5514 25.3722 28.307 25.1278 28.0055 25.1278ZM25.4595 25.6737C25.4595 24.2677 26.5994 23.1278 28.0055 23.1278C29.4115 23.1278 30.5514 24.2677 30.5514 25.6737C30.5514 27.0798 29.4115 28.2197 28.0055 28.2197C26.5994 28.2197 25.4595 27.0798 25.4595 25.6737Z"
        fill="currentColor"
      />
    </svg>
  ),
  "made-in-KR": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        d="M52 41.0726H4L9.91885 28.156H46.0812L52 41.0726Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M43.1214 28.156H12.8779V25.1041H43.1214V28.156Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M43.1214 21.9231H12.8779V18.8712H43.1214V21.9231Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M47.162 15.6896C47.162 18.576 43.1207 18.8712 43.1207 18.8712H12.8772C12.8772 18.8712 8.83594 18.576 8.83594 15.6896C12.2367 16.8899 14.8502 14.9272 14.8502 14.9272H41.1477C41.1477 14.9272 43.7612 16.8899 47.162 15.6896Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M43.1198 21.9222C43.1198 21.9222 45.8842 23.7279 49.285 22.5276C49.285 25.414 43.1198 25.1038 43.1198 25.1038H27.998"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M12.8783 21.9222C12.8783 21.9222 10.1138 23.7279 6.71307 22.5276C6.71307 25.414 12.8783 25.1038 12.8783 25.1038H28"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M30.9814 36.3779C30.9814 34.7315 29.6467 33.3967 28.0002 33.3967V33.3967C26.3538 33.3967 25.0191 34.7315 25.0191 36.3779V41.0724H30.9814V36.3779Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "made-in-JP": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.0096 15.2502C42.3906 15.2209 42.7131 15.1953 42.9653 15.175L43.7548 13.1204L43.6903 13.1294C42.5929 13.2827 41.0589 13.4872 39.3114 13.6916C35.8274 14.0993 31.4542 14.5121 28 14.5121C24.5457 14.5121 20.1725 14.0993 16.6885 13.6916C14.941 13.4872 13.407 13.2827 12.3096 13.1294L12.2451 13.1204L13.0346 15.175C13.2868 15.1953 13.6093 15.2209 13.9904 15.2502C14.9778 15.3262 16.3581 15.4277 17.9292 15.529C21.0775 15.7322 24.9692 15.9338 28 15.9338C31.0307 15.9338 34.9225 15.7322 38.0707 15.529C39.6418 15.4277 41.0221 15.3263 42.0096 15.2502ZM45.1479 10.8965L45.3008 11.8847L45.1478 10.8965L45.1476 10.8965L45.1463 10.8967L45.141 10.8975L45.119 10.9009L45.0313 10.9143C44.9537 10.926 44.8386 10.9433 44.6894 10.9654C44.391 11.0096 43.9565 11.0727 43.4135 11.1486C42.3273 11.3004 40.8085 11.5028 39.079 11.7052C35.6091 12.1112 31.3319 12.5121 28 12.5121C24.668 12.5121 20.3908 12.1112 16.9209 11.7052C15.1914 11.5028 13.6726 11.3004 12.5864 11.1486C12.0435 11.0727 11.6089 11.0096 11.3105 10.9654C11.1613 10.9433 11.0462 10.926 10.9686 10.9143L10.8809 10.9009L10.8589 10.8975L10.8536 10.8967L10.8523 10.8965L10.8521 10.8965L10.6991 11.8847L10.852 10.8965L9.76562 12.2434L11.393 16.4788L12.2416 17.1165L12.2528 16.9843L12.2529 16.9844C12.2416 17.1165 12.2417 17.1165 12.2417 17.1165L12.2421 17.1165L12.2435 17.1167L12.2489 17.1171L12.27 17.1189L12.3188 17.123L13.674 19.9723L14.577 20.5428H16.0928V24.0995H14.5771L13.5771 25.0995V28.5212L14.5771 29.5212H16.0928V46.1051L17.0928 47.1051H21.2004L22.2004 46.1051V29.5212H33.6034V46.1051L34.6034 47.1051H38.7109L39.7109 46.1051V29.5212H41.4232L42.4232 28.5212V25.0995L41.4232 24.0995H39.7109V20.5428H41.4231L42.3262 19.9723L43.6814 17.123L43.7299 17.1189L43.751 17.1171L43.7564 17.1167L43.7578 17.1165L43.7582 17.1165L43.7471 16.9848L43.7471 16.9847L43.7584 17.1165L44.6069 16.4788L46.2343 12.2434L45.1479 10.8965ZM37.7109 29.5212H35.6034V45.1051H37.7109V29.5212ZM38.7109 27.5212H40.4232V26.0995L15.5771 26.0995V27.5212H17.0928H21.2004H34.6034H38.7109ZM15.2087 18.5428L14.6193 17.3036C15.5095 17.3699 16.5995 17.4474 17.8004 17.5249C20.9566 17.7286 24.9016 17.9338 28 17.9338C31.0983 17.9338 35.0433 17.7286 38.1995 17.5249C39.4005 17.4474 40.4906 17.3699 41.3808 17.3036L40.7914 18.5428L15.2087 18.5428ZM22.2004 24.0995V20.5428H33.6034V24.0995L22.2004 24.0995ZM18.0928 45.1051V29.5212H20.2004V45.1051H18.0928ZM20.2004 20.7773V24.0982H18.0928V20.7773H20.2004ZM37.7109 24.0982V20.7773H35.6034V24.0982H37.7109Z"
        fill="currentColor"
      />
    </svg>
  ),
  "made-in-ID": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        d="M41.8745 43.0129H14.1895V45.8701L21.971 50H33.3501L41.8745 45.8701V43.0129Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M25.4326 19.2475L22.4062 15.9254H33.6552L30.6289 19.2475"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M26.3915 15.9254H29.6675L32.7582 43.013H23.3008L26.3915 15.9254Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path d="M14.126 45.3979H41.8116" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path
        d="M24.8581 11.4011C24.0405 13.1824 24.5699 14.784 25.6298 15.9239L29.8336 15.9239C29.8336 15.9239 31.254 14.3377 31.254 11.4011C31.254 9.12924 25.6298 4.93939 27.1702 6.24782C29.1681 7.94478 25.6756 9.61975 24.8581 11.4011Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M27.4864 15.9393C27.4864 15.9393 28.7156 14.6063 27.4864 12.0378C26.6051 10.1961 27.7723 7.88928 27.7723 7.88928"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "made-in-ES": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1181 10.3521C21.1181 10.1574 21.2759 9.99951 21.4706 9.99951C21.6653 9.99951 21.8232 10.1574 21.8232 10.3521C21.8232 10.5468 21.6653 10.7046 21.4706 10.7046C21.2759 10.7046 21.1181 10.5468 21.1181 10.3521ZM21.4706 7.99951C20.1714 7.99951 19.1181 9.05278 19.1181 10.3521C19.1181 11.6513 20.1714 12.7046 21.4706 12.7046C22.7699 12.7046 23.8232 11.6513 23.8232 10.3521C23.8232 9.05278 22.7699 7.99951 21.4706 7.99951ZM23.2992 15.0154C22.8306 12.9346 19.8656 12.9346 19.397 15.0154L18.9321 17.0794C18.5062 16.4759 17.8035 16.0818 17.0087 16.0818C15.7094 16.0818 14.6561 17.135 14.6561 18.4343C14.6561 19.7336 15.7094 20.7869 17.0087 20.7869C17.4292 20.7869 17.824 20.6765 18.1656 20.4832L17.8782 21.7593C17.8457 21.9035 17.8293 22.0508 17.8293 22.1987V22.4045C16.7149 21.9362 15.1904 22.4755 15.0201 24.0224L14.1935 31.5303L14.1875 31.6398V47L15.1875 48H18.8287L18.8296 47.9991H19.759C19.7824 47.9999 19.8058 48.0004 19.8293 48.0004H22.8669C22.8904 48.0004 22.9138 47.9999 22.9372 47.9991H23.8671L23.8673 47.9993H32.134L32.1342 47.9991H33.0565C33.0819 48.0001 33.1074 48.0006 33.1331 48.0006H36.1706C36.1962 48.0006 36.2217 48.0001 36.2471 47.9991H37.1702L37.171 48H40.8123L41.8123 47V31.6398L41.8063 31.5303L40.9797 24.0224C40.8093 22.4755 39.2851 21.9362 38.1706 22.4044V22.1989C38.1706 22.0511 38.1542 21.9037 38.1217 21.7595L37.8341 20.4825C38.176 20.6763 38.5712 20.7869 38.9922 20.7869C40.2915 20.7869 41.3448 19.7336 41.3448 18.4343C41.3448 17.135 40.2915 16.0818 38.9922 16.0818C38.1969 16.0818 37.4938 16.4764 37.068 17.0805L36.603 15.0156C36.1344 12.9348 33.1693 12.9348 32.7007 15.0156L31.1819 21.7595C31.1495 21.9037 31.1331 22.0511 31.1331 22.1989V25.5136L28.4005 24.3216H27.6008L24.8669 25.5142V22.1987C24.8669 22.0508 24.8505 21.9035 24.818 21.7593L23.2992 15.0154ZM39.8123 46H38.6692V45.9991H38.171V31.6947L38.9917 24.2412L39.8123 31.6947V46ZM36.1706 45.9991V22.1989L34.6518 15.455L33.1331 22.1989V27.0398L33.134 27.0412V45.9991H36.1706ZM31.1331 45.9991V27.6956L28.0006 26.3292L24.8673 27.696V45.9991H31.1331ZM22.8669 45.9991V22.1987L21.3481 15.4548L19.8293 22.1987V45.9991H22.8669ZM17.8287 45.9991V31.6947L17.0081 24.2412L16.1875 31.6947V46H16.8864V45.9991H17.8287ZM27.189 32.9153C27.189 32.4716 27.5487 32.1119 27.9924 32.1119C28.4361 32.1119 28.7958 32.4716 28.7958 32.9153C28.7958 33.359 28.4361 33.7187 27.9924 33.7187C27.5487 33.7187 27.189 33.359 27.189 32.9153ZM27.9924 30.1119C26.4442 30.1119 25.189 31.3671 25.189 32.9153C25.189 34.4636 26.4442 35.7187 27.9924 35.7187C29.5407 35.7187 30.7958 34.4636 30.7958 32.9153C30.7958 31.3671 29.5407 30.1119 27.9924 30.1119ZM17.0087 18.0818C16.814 18.0818 16.6561 18.2396 16.6561 18.4343C16.6561 18.629 16.814 18.7869 17.0087 18.7869C17.2034 18.7869 17.3612 18.629 17.3612 18.4343C17.3612 18.2396 17.2034 18.0818 17.0087 18.0818ZM34.3975 9.99951C34.2028 9.99951 34.045 10.1574 34.045 10.3521C34.045 10.5468 34.2028 10.7046 34.3975 10.7046C34.5922 10.7046 34.7501 10.5468 34.7501 10.3521C34.7501 10.1574 34.5922 9.99951 34.3975 9.99951ZM32.045 10.3521C32.045 9.05278 33.0983 7.99951 34.3975 7.99951C35.6968 7.99951 36.7501 9.05278 36.7501 10.3521C36.7501 11.6513 35.6968 12.7046 34.3975 12.7046C33.0983 12.7046 32.045 11.6513 32.045 10.3521ZM38.6397 18.4343C38.6397 18.2396 38.7975 18.0818 38.9922 18.0818C39.187 18.0818 39.3448 18.2396 39.3448 18.4343C39.3448 18.629 39.187 18.7869 38.9922 18.7869C38.7975 18.7869 38.6397 18.629 38.6397 18.4343Z"
        fill="currentColor"
      />
    </svg>
  ),
  "made-in-CZ": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        d="M42.0664 16.9541H28.9548V47.9997H42.0664V16.9541Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M28.9541 16.9534C28.9541 16.9534 25.975 14.7736 23.7385 14.6726C21.8432 14.5871 19.0657 15.4846 19.0657 15.4846C19.0657 15.4846 19.9554 25.4966 18.5512 31.3783C16.8534 38.4897 9.93406 47.999 9.93406 47.999H28.9541V16.9534Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M25.4574 14.9905C25.4574 14.9905 26.3471 25.4976 24.9429 31.3793C23.2451 38.4907 16.3258 48 16.3258 48"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M40.0295 16.2035C40.0295 13.7076 38.0062 11.6843 35.5104 11.6843C33.0145 11.6843 30.9912 13.7076 30.9912 16.2035"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path d="M35.5098 11.6525L35.5098 8.00005" stroke="currentColor" strokeWidth="2" />
      <path d="M39.6191 23.3525H31.4012" stroke="currentColor" strokeWidth="2" />
      <path d="M39.6191 29.5153H31.4012" stroke="currentColor" strokeWidth="2" />
      <path
        d="M28.9541 29.5153C28.9541 29.5153 26.8139 28.279 25.3247 27.7773C23.125 27.0363 19.4432 26.9204 19.4432 26.9204"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M28.9541 23.3525C28.9541 23.3525 26.7484 21.7383 25.2592 21.2366C23.0595 20.4957 19.4432 20.7577 19.4432 20.7577"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M39.6191 35.6801H31.4012" stroke="currentColor" strokeWidth="2" />
      <path d="M39.6191 41.8427H31.4012" stroke="currentColor" strokeWidth="2" />
      <path
        d="M28.7119 43.297C28.7119 43.297 26.2842 41.641 23.5245 40.9825C20.1209 40.1704 14.3937 40.7681 14.3937 40.7681"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M28.7119 36.4071C28.7119 36.4071 26.2842 34.7512 23.5245 34.0927C21.9038 33.7059 19.7562 33.6389 17.951 33.6748"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  "made-in-CN": (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path
        d="M32.7435 49.9859C36.9106 47.7195 44.6704 43.1518 44.6518 34.0861"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M10.083 48.0021C15.426 45.0877 30.3722 37.7006 30.3 33.3154C30.2514 30.3622 25.896 29.1197 22.5543 28.6967"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M28.1068 6.01416C23.0334 8.29844 12.8867 14.3567 12.8867 20.3153C12.8867 26.2739 18.8959 28.3392 21.9005 28.6271"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M23.3721 28.3859V14.9614H27.6279V19.4578H31.8838V14.9614H36.1396V19.4578H40.3955V14.9614H44.6514V33.1425V34.6383H38.3456V26.8462C38.3456 24.5905 36.3844 22.7619 33.9653 22.7619C31.5461 22.7619 29.585 24.5905 29.585 26.8462V31.7989"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path d="M12.8867 46.6585L12.8867 20.323" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path
        d="M42.8085 8.08716L43.7573 7.7711L43.1251 5.87362L42.1764 6.18969L42.8085 8.08716ZM42.1764 6.18969C40.3465 6.79932 38.1608 8.07982 36.4237 9.62896C35.5512 10.4071 34.7631 11.2783 34.187 12.1988C33.6142 13.1143 33.2158 14.1357 33.2158 15.1934L35.2158 15.1934C35.2158 14.6351 35.4304 13.9821 35.8824 13.2598C36.3312 12.5426 36.9799 11.8127 37.7549 11.1216C39.3129 9.73219 41.2655 8.6012 42.8085 8.08716L42.1764 6.18969Z"
        fill="currentColor"
      />
    </svg>
  ),
  kiko: (
    <svg
      width="78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 78 28"
      aria-labelledby="kikoTitle"
      role="img"
    >
      <title id="kikoTitle">KIKO MILANO</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.289 23.663c.312 0 .614.055.903.166.289.109.543.266.763.47.22.202.388.435.506.696.117.262.175.54.175.836 0 .297-.059.577-.173.836-.116.26-.286.493-.508.697-.224.204-.48.359-.767.472a2.53 2.53 0 0 1-1.8 0 2.363 2.363 0 0 1-.758-.472 2.1 2.1 0 0 1-.516-.699 2.028 2.028 0 0 1-.174-.834 2.013 2.013 0 0 1 .69-1.532c.22-.204.47-.361.758-.47.287-.11.586-.166.9-.166Zm-30.894.093.664 2.133.024.073c.062.189.101.353.118.488.007-.073.022-.155.043-.244.024-.089.052-.197.09-.324l.671-2.126h1.187l.675 4.133h-1.119l-.258-1.785c-.017-.126-.032-.268-.05-.421a19.711 19.711 0 0 1-.04-.506 4.503 4.503 0 0 1-.164.654c-.018.056-.033.096-.04.122l-.598 1.936H23.8l-.597-1.936-.034-.122a4.07 4.07 0 0 1-.166-.652 15.732 15.732 0 0 1-.1.925l-.258 1.785h-1.114l.679-4.133h1.185Zm7.252 0v4.133h-1.211v-4.133h1.21Zm4.053 0v3.168h1.49v.965h-2.688v-4.133H34.7Zm6.467 0 1.517 4.133h-1.191l-.222-.738h-1.7l-.229.738H38.15l1.515-4.133h1.502Zm4.985 0 1.659 2.126c.032.042.084.131.157.262.074.13.153.286.242.466a8.17 8.17 0 0 1-.052-.457 4.46 4.46 0 0 1-.017-.355v-2.042h1.15v4.133h-1.15l-1.66-2.133a2.497 2.497 0 0 1-.159-.262 9.003 9.003 0 0 1-.24-.461c.024.173.042.326.055.459.01.135.015.253.015.357v2.04h-1.155v-4.133h1.155Zm8.137.86c-.332 0-.606.115-.823.346-.218.23-.326.521-.326.87 0 .354.106.645.321.87.214.23.49.345.828.345.332 0 .605-.116.823-.344a1.22 1.22 0 0 0 .328-.872c0-.346-.11-.634-.332-.867a1.08 1.08 0 0 0-.82-.348Zm-13.867-.19-.076.29c-.026.093-.051.18-.077.266l-.442 1.364h1.192l-.449-1.364a4.333 4.333 0 0 1-.056-.202l-.092-.355ZM66.4 0c2.435.018 4.864.51 7.018 1.705 1.798.983 3.285 2.592 4.026 4.56.32.88.506 1.817.547 2.76L78 9.34v.193c-.015 1.421-.358 2.838-1.04 4.076-.936 1.745-2.507 3.064-4.263 3.86-2.888 1.284-6.138 1.592-9.232 1.104-2.369-.379-4.715-1.33-6.476-3.037-1.618-1.601-2.631-3.89-2.523-6.218.036-1.991.661-4.007 1.965-5.51C58.196 1.775 60.75.635 63.333.214a20.89 20.89 0 0 1 2.372-.207L66.182 0h.218ZM26.873.315c-.006 6.058-.004 12.116-.002 18.174-1.099-.009-2.196 0-3.295-.006.005-6.056.007-12.108-.002-18.164l3.3-.004ZM52.364.34c-3.456 2.42-6.88 4.892-10.324 7.338 3.57 3.61 7.165 7.196 10.758 10.786-1.449.049-2.899.004-4.35.022-2.917-3.049-5.82-6.116-8.731-9.17-1.334.968-2.68 1.915-4.006 2.892.01 2.091-.004 4.183.006 6.276-1.096.002-2.195-.002-3.295.004.003-6.058.003-12.116-.002-18.174 1.102.007 2.2 0 3.3.002-.011 2.991-.01 5.983-.003 8.972 4.039-3.007 8.114-5.96 12.15-8.972 1.5.013 3-.027 4.498.024ZM19.938.337C16.48 2.763 13.054 5.231 9.612 7.68c3.573 3.61 7.165 7.2 10.76 10.79-1.45.038-2.903.002-4.353.018-2.918-3.053-5.814-6.127-8.743-9.167-1.325.976-2.679 1.912-4.002 2.894.009 2.09-.006 4.18.009 6.27-1.093.003-2.187 0-3.282 0-.002-6.055 0-12.111 0-18.167C1.096.32 2.193.313 3.287.322c-.02 2.984-.008 5.971-.008 8.956 4.055-2.98 8.115-5.954 12.15-8.96 1.504.012 3.005-.025 4.507.02Zm40.48 3.455a5.342 5.342 0 0 0-1.915 2.31c-.681 1.566-.746 3.342-.539 5.02.198.888.541 1.744 1.073 2.476 1.304 1.727 3.37 2.703 5.446 2.984 2.138.277 4.403.113 6.357-.887 1.534-.76 2.873-2.082 3.398-3.78.692-2.22.466-4.82-.9-6.724-1.155-1.61-3.017-2.503-4.881-2.89-2.726-.523-5.7-.108-8.038 1.49Z"
        fill="currentColor"
      />
    </svg>
  ),
  "kiko-small": (
    <svg width="80" height="80" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.07 14.997v5.395a.324.324 0 0 1-.122.249l-3.37 2.377a.318.318 0 0 1-.413-.04l-7.135-7.293a.323.323 0 0 1 .036-.483l8.836-6.23h-3.857l-10.63 7.497a.322.322 0 0 1-.165.048.322.322 0 0 1-.32-.324V8.972H9.07v16.116h2.858v-5.394a.324.324 0 0 1 .123-.249l3.34-2.356a.316.316 0 0 1 .413.04l.002-.002 7.144 7.302a.319.319 0 0 1-.044.47l-8.81 6.215h3.858l10.63-7.497a.323.323 0 0 1 .165-.048c.177 0 .32.145.32.323v7.223h2.858V14.997h-2.857Z"
        fill="currentColor"
      />
    </svg>
  ),
  "inclined-star": (
    <svg height="8" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m5.297.06.842 2.823 2.83.928-2.457 1.648-.007 2.938-2.36-1.804-2.833.888.998-2.763L.565 2.33l2.977.096L5.297.061Z"
        fill="currentColor"
      />
    </svg>
  ),
  "shipping-illustration": (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
      <circle cx="17" cy="38.5" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="40" cy="38.5" r="4.5" stroke="currentColor" strokeWidth="2" />
      <path d="M21.5 37H35.5" stroke="currentColor" strokeWidth="2" />
      <path
        d="M12.6622 37L9.5 37L9.5 14L32.6892 14L32.6892 18.7045M32.6892 37L32.6892 18.7045M32.6892 18.7045L41.1216 18.7045L43.2297 26.0227L48.5 28.1136L48.5 37L44.2838 37"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path d="M17.5 14H24.5V23L21 20.75L17.5 23V14Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "click-collect": (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
      <path
        d="M19.9444 17.4894C19.9444 11.7213 23.7252 8 28.3889 8C33.0526 8 36.8333 11.7213 36.8333 17.4894M26.5295 40.0897L27.809 38.8434M26.3099 33.8586H24.5004M28.2355 29.2892L26.956 28.043M33.0304 27.3131V25.5507M38.0452 28.8738L39.3247 27.6276M43.1687 37.3171L31.2211 32.197L36.6098 44.6435M43.1687 37.3171L49.5 40.0303L44.7189 42.3091L49.2101 46.6958L46.0948 49.7301L41.6035 45.3433L39.2638 50L36.6098 44.6435M43.1687 37.3171C43.8776 30.4782 44.4362 25.6084 45.2778 17.4894H11.5L14.3148 44.6435H36.6098"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "returns-days": (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3587 5.99854V11.9845C23.6035 5.41847 35.6925 5.92307 43.3464 13.4983C49.636 19.7232 51.1049 28.9155 47.7521 36.5265C46.8322 38.6148 45.2294 41.0494 43.3464 42.9131C35.1463 51.0289 21.8554 51.0289 13.6553 42.9131C7.36564 36.6882 5.89679 27.4959 9.24955 19.8848L11.0798 20.6911C8.0515 27.5656 9.37865 35.8666 15.0621 41.4916C22.483 48.8361 34.5187 48.8361 41.9395 41.4916C43.6349 39.8137 45.0979 37.5908 45.9218 35.7203C48.9502 28.8457 47.623 20.5448 41.9395 14.9198C35.1483 8.1984 24.492 7.62815 17.0449 13.209H22.4989V15.209H14.3587L13.3587 14.209V5.99854H15.3587ZM23.4385 17.9999H23.0121L22.7169 18.3076L18.7794 22.411L18.501 22.7012V23.1034V35.9999V36.9999H19.501H37.501H38.501V35.9999V23.1034V22.7012L38.2225 22.411L34.285 18.3076L33.9898 17.9999H33.5635H23.4385ZM21.8465 22.1034L23.8648 19.9999H33.1371L35.1555 22.1034H21.8465ZM20.501 24.1034H36.501V34.9999H20.501V24.1034Z"
        fill="currentColor"
      />
    </svg>
  ),
  "appointment-illustration": (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
      <circle cx="41.5" cy="42" r="8" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M36.5 41.7692L40.1364 45L46.5 39" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <rect x="27.5" y="27" width="3" height="3" rx="1.5" fill="currentColor" />
      <rect x="27.5" y="35" width="3" height="3" rx="1.5" fill="currentColor" />
      <rect x="37.5" y="27" width="3" height="3" rx="1.5" fill="currentColor" />
      <rect x="17.5" y="27" width="3" height="3" rx="1.5" fill="currentColor" />
      <rect x="17.5" y="9" width="5" height="8" rx="2.5" stroke="currentColor" strokeWidth="2" />
      <rect x="34.5" y="9" width="5" height="8" rx="2.5" stroke="currentColor" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 13H13.5C11.2909 13 9.5 14.7909 9.5 17V22V41C9.5 43.2091 11.2909 45 13.5 45H34.0815C33.8262 44.3693 33.649 43.6986 33.5619 43H13.5C12.3954 43 11.5 42.1046 11.5 41V23H45.5V35.0703C46.2528 35.5057 46.9281 36.0604 47.5 36.7084V22V17C47.5 14.7909 45.7091 13 43.5 13H39.5V14.5C39.5 14.6712 39.4828 14.8384 39.45 15H43.5C44.6046 15 45.5 15.8954 45.5 17V21H11.5V17C11.5 15.8954 12.3954 15 13.5 15H17.55C17.5172 14.8384 17.5 14.6712 17.5 14.5V13ZM22.45 15H34.55C34.5172 14.8384 34.5 14.6712 34.5 14.5V13H22.5V14.5C22.5 14.6712 22.4828 14.8384 22.45 15Z"
        fill="currentColor"
      />
      <rect x="17.5" y="35" width="3" height="3" rx="1.5" fill="currentColor" />
    </svg>
  ),
  personalize: (
    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="60" viewBox="0 0 69 60" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5938 47.6288L29.3926 48.4277V50.9991C29.3926 53.2083 31.1834 54.9991 33.3926 54.9991H36.1891C38.3982 54.9991 40.1891 53.2083 40.1891 50.9991V48.4294L40.9896 47.6288V15C40.9896 12.2386 38.7511 10 35.9896 10H33.5938C30.8323 10 28.5938 12.2386 28.5938 15L28.5938 47.6288ZM30.5938 46.6288H38.9896V15C38.9896 13.3431 37.6465 12 35.9896 12L33.5938 12C31.9369 12 30.5938 13.3432 30.5938 15L30.5938 46.6288ZM31.3926 48.6289H38.1891V50.9991C38.1891 52.1037 37.2937 52.9991 36.1891 52.9991H33.3926C32.288 52.9991 31.3926 52.1037 31.3926 50.9991V48.6289ZM16.6384 18.687L16.5996 18.9628L16.5996 23.5373H16L15 24.5373V32.5001L15.3975 32.8976L15 33.2951V50.9984C15 53.2075 16.7909 54.9984 19 54.9984H21.7965C24.0057 54.9984 25.7965 53.2075 25.7965 50.9984L25.7965 33.2951L25.399 32.8976L25.7965 32.5001L25.7965 24.5373L24.7965 23.5373H24.1974L24.1974 18.9628L24.1586 18.687L22.5592 13.113L21.598 12.3888H19.199L18.2378 13.113L16.6384 18.687ZM18.5996 19.1034L19.9524 14.3888H20.8446L22.1974 19.1034V23.5368H18.5996L18.5996 19.1034ZM23.7965 25.5373L17 25.5373L17 31.5001H23.7965V25.5373ZM23.7965 34.2951H17L17 50.9983C17 52.1029 17.8954 52.9984 19 52.9984H21.7965C22.9011 52.9984 23.7965 52.1029 23.7965 50.9984L23.7965 34.2951Z"
        fill="currentColor"
      />
      <clipPath id="rainbowCircleClipPersonalize">
        <path d="M 43.5 8.5 A 7.5 7.5 90 0 0 36 16 a 7.5 7.5 90 0 0 7.5 7.5 A 7.5 7.5 90 0 0 51 16 a 7.5 7.5 90 0 0 -7.5 -7.5 z m 0 5 A 2.5 2.5 90 0 1 46 16 a 2.5 2.5 90 0 1 -2.5 2.5 A 2.5 2.5 90 0 1 41 16 a 2.5 2.5 90 0 1 2.5 -2.5 z" />
      </clipPath>
      <foreignObject x="0" y="0" width="100%" height="100%" clipPath="url(#rainbowCircleClipPersonalize)">
        <div
          className="gradient"
          style={{
            position: "relative",
            top: "-23.5%",
            left: "12.5%",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundImage:
              "conic-gradient(from 270deg, #ff4800 10%, #dfd902 35%, #20dc68, #0092f4, #da54d8 72% 75%, #ff4800 95%)",
          }}
        />
      </foreignObject>
    </svg>
  ),
  "privacy-options": (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 30 14">
      <g>
        <g>
          <g transform="translate(-1275.000000, -200.000000)">
            <g transform="translate(1275.000000, 200.000000)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#FFFFFF"
                d="M7.4,12.8h6.8l3.1-11.6H7.4C4.2,1.2,1.6,3.8,1.6,7S4.2,12.8,7.4,12.8z"
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(-1275.000000, -200.000000)">
            <g transform="translate(1275.000000, 200.000000)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#0066FF"
                d="M22.6,0H7.4c-3.9,0-7,3.1-7,7s3.1,7,7,7h15.2c3.9,0,7-3.1,7-7S26.4,0,22.6,0z M1.6,7c0-3.2,2.6-5.8,5.8-5.8      h9.9l-3.1,11.6H7.4C4.2,12.8,1.6,10.2,1.6,7z"
              />
              <path
                fill="#FFFFFF"
                d="M24.6,4c0.2,0.2,0.2,0.6,0,0.8l0,0L22.5,7l2.2,2.2c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.2-0.6,0.2-0.8,0      l0,0l-2.2-2.2L19.5,10c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8l0,0L20.8,7l-2.2-2.2c-0.2-0.2-0.2-0.6,0-0.8      c0.2-0.2,0.6-0.2,0.8,0l0,0l2.2,2.2L23.8,4C24,3.8,24.4,3.8,24.6,4z"
              />
              <path
                fill="#0066FF"
                d="M12.7,4.1c0.2,0.2,0.3,0.6,0.1,0.8l0,0L8.6,9.8C8.5,9.9,8.4,10,8.3,10c-0.2,0.1-0.5,0.1-0.7-0.1l0,0      L5.4,7.7c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l0,0L8,8.6l3.8-4.5C12,3.9,12.4,3.9,12.7,4.1z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  "kisses-illustration": (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
      <path
        d="M33.5 28C33.5 28.5 31.5 30.5 28.5 30.5C25.5 30.5 23.5 28.5 23.5 28C23.5 27.5 25.5 26 28.5 26C31.5 26 33.5 27.5 33.5 28Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.3969 26.3197C45.4611 26.5459 45.5 26.7748 45.5 27C45.5 27.5509 45.2681 28.1767 44.9935 28.7508C44.7006 29.3632 44.2864 30.0619 43.7841 30.8031C42.7782 32.2877 41.3758 34.0067 39.7613 35.6404C38.1483 37.2726 36.2985 38.8452 34.3922 40.0161C32.5011 41.1778 30.4641 42 28.5 42C26.5251 42 24.4828 41.138 22.5947 39.9377C20.6897 38.7265 18.8418 37.107 17.2319 35.446C15.6199 33.7828 14.2218 32.0525 13.2202 30.5986C12.7203 29.8728 12.3088 29.201 12.0177 28.6299C11.8723 28.3448 11.7495 28.0702 11.6609 27.8164C11.5777 27.5782 11.5 27.2903 11.5 27C11.5 26.6919 11.6006 26.4064 11.688 26.2025C11.7842 25.9779 11.9141 25.7412 12.0605 25.5034C12.3541 25.0264 12.7607 24.4702 13.2337 23.8769C14.1831 22.6862 15.4579 21.2743 16.7873 19.9238C18.1161 18.5738 19.5198 17.2645 20.7305 16.2851C21.3338 15.797 21.9088 15.375 22.4151 15.0695C22.6682 14.9169 22.9221 14.7824 23.1669 14.6835C23.399 14.5899 23.6906 14.5 24 14.5C24.3461 14.5 24.6543 14.637 24.8427 14.733C25.0619 14.8446 25.2885 14.9915 25.5077 15.1494C25.9486 15.4668 26.4416 15.8878 26.9176 16.3294C27.468 16.8399 28.0319 17.4118 28.5 17.9314C28.9681 17.4118 29.532 16.8399 30.0824 16.3294C30.5584 15.8878 31.0514 15.4668 31.4923 15.1494C31.7115 14.9915 31.9381 14.8446 32.1573 14.733C32.3457 14.637 32.6539 14.5 33 14.5C33.5321 14.5 34.1 14.7649 34.5545 15.0177C34.8633 15.1895 35.1978 15.4018 35.549 15.6447C35.2134 16.23 35.0215 16.9083 35.0215 17.6315L35.0323 17.7391C34.4686 17.3147 33.9763 16.9847 33.5822 16.7655C33.307 16.6124 33.138 16.5472 33.0561 16.5197C32.9625 16.5682 32.8304 16.6504 32.6608 16.7725C32.3132 17.0228 31.8874 17.383 31.4426 17.7956C30.5424 18.6306 29.6734 19.5777 29.3137 20.0812C29.126 20.344 28.823 20.5 28.5 20.5C28.177 20.5 27.874 20.344 27.6863 20.0812C27.3266 19.5777 26.4576 18.6306 25.5574 17.7956C25.1126 17.383 24.6868 17.0228 24.3392 16.7725C24.1745 16.654 24.0452 16.573 23.9521 16.524C23.9412 16.528 23.929 16.5327 23.9156 16.5382C23.8016 16.5842 23.6463 16.6626 23.4482 16.7821C23.0521 17.021 22.5568 17.3802 21.9883 17.8401C20.8552 18.7567 19.5089 20.01 18.2127 21.3268C16.9171 22.643 15.6919 24.002 14.7975 25.1238C14.3487 25.6867 13.9974 26.1721 13.7637 26.5518C13.6464 26.7423 13.5703 26.8877 13.5264 26.9902C13.5197 27.0056 13.5144 27.0189 13.51 27.0301C13.5171 27.0581 13.5291 27.0999 13.5491 27.1572C13.5986 27.2989 13.68 27.4872 13.7995 27.7216C14.0381 28.1896 14.3985 28.7834 14.8673 29.4639C15.8032 30.8225 17.1301 32.4672 18.6681 34.054C20.2082 35.643 21.9353 37.1485 23.6678 38.2498C25.4172 39.362 27.0749 40 28.5 40C29.9359 40 31.5989 39.3847 33.3453 38.312C35.0765 37.2486 36.8017 35.7899 38.3387 34.2346C39.8742 32.6808 41.1968 31.056 42.1284 29.6812C42.5949 28.9928 42.9525 28.3829 43.1893 27.8878C43.4444 27.3546 43.5 27.0741 43.5 27C43.5 27 43.5 26.9991 43.4999 26.9971C43.4998 26.9948 43.4995 26.9911 43.4989 26.9859C43.4979 26.976 43.4958 26.9618 43.492 26.9428C43.4843 26.9043 43.4706 26.852 43.4474 26.7848C43.4208 26.7075 43.3844 26.6184 43.3371 26.5174L43.9712 26.5812C44.4734 26.5812 44.9541 26.4887 45.3969 26.3197ZM23.8619 16.4823C23.8619 16.4823 23.8636 16.4828 23.8673 16.4841C23.8638 16.4831 23.8619 16.4824 23.8619 16.4823ZM33.1381 16.4823C33.1381 16.4824 33.1362 16.4831 33.1326 16.4842C33.1363 16.4828 33.1381 16.4823 33.1381 16.4823Z"
        fill="currentColor"
      />
      <path
        d="M47.9712 22.5812C47.9712 20.3721 46.1804 18.5812 43.9712 18.5812C43.5883 18.5812 43.2178 18.635 42.8672 18.7355C42.9677 18.3848 43.0215 18.0144 43.0215 17.6315C43.0215 15.4223 41.2306 13.6315 39.0215 13.6315C36.8123 13.6315 35.0215 15.4223 35.0215 17.6315L35.8395 25.7632L43.9712 26.5812C46.1804 26.5812 47.9712 24.7904 47.9712 22.5812Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "secure-payment": (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
      <path
        d="M10.2267 13.6408C10.0238 24.0004 9.79416 35.7571 24.7704 41.1429C39.754 35.7571 39.519 23.9921 39.2528 13.6408V12.2047C33.9341 12.0747 28.8177 10.1894 24.7397 6.85718C20.6625 10.1894 15.546 12.0747 10.2267 12.2047V13.6408Z"
        stroke="currentColor"
        strokeWidth="currentStroke"
        strokeLinejoin="bevel"
      />
      <path
        d="M17.0356 24.066L22.646 29.1429L32.4642 19.7144"
        stroke="currentColor"
        strokeWidth="currentStroke"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  sustainability: (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
      <path
        d="M38.8052 27.9228C40.9085 19.7615 36.1341 11.341 28.1414 9.11513C24.2871 8.04174 20.3882 8.60488 17.1482 10.391M38.8052 27.9228L35.4842 23.5922M38.8052 27.9228L43.1069 25.3938M9.37091 29.0703C12.096 37.0386 20.6713 41.3156 28.5243 38.6232C31.3869 37.6418 33.7584 35.8698 35.4845 33.628M9.37091 29.0703L7.10693 33.7769M9.37091 29.0703L13.9372 31.3478"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M15.0488 19.5593C18.4647 20.7531 24.5342 25.6572 26.7909 29.7234C27.7807 27.9056 29.2895 25.4812 31.5356 23.7722M22.7015 24.7148C20.6884 27.5472 18.7112 28.2481 16.9557 27.9484C13.5791 27.3719 11.0587 23.0936 10.0529 20.3559C9.24829 18.1658 8.92696 16.8646 8.86687 16.4878C10.2871 15.8749 14.1987 14.942 18.4839 16.1135C23.8403 17.5778 24.7147 21.8825 22.7015 24.7148Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  help: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4.9996H8V2.9996H12V4.9996H11V6.07245C14.3923 6.55767 17 9.47508 17 13.0016V14.0016H16H4H3V13.0016C3 9.47508 5.60771 6.55767 9 6.07245V4.9996ZM5.10002 12.0016H14.9C14.4367 9.71932 12.419 8.00156 10 8.00156C7.58104 8.00156 5.56329 9.71932 5.10002 12.0016ZM18 14.9996V16.9996H2V14.9996H18Z"
        fill="currentColor"
      />
    </svg>
  ),
  "brokenheart-illustration": (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.9286 14.7037L30.2059 14.0125L30.9286 14.7037ZM29.8041 16.1447L30.6476 16.6819V16.6819L29.8041 16.1447ZM26.1959 16.1447L27.0393 15.6076L27.0393 15.6076L26.1959 16.1447ZM25.0714 14.7051L24.3488 15.3963L24.3496 15.3972L25.0714 14.7051ZM12.6106 14.7051L11.8879 14.0139L12.6106 14.7051ZM12.6105 27.9104L11.8878 28.6016L11.8878 28.6016L12.6105 27.9104ZM27.9999 44L27.2773 44.6912L28.7226 44.6912L27.9999 44ZM43.3895 27.9091L44.1121 28.6002L43.3895 27.9091ZM43.3893 14.7036L44.1121 14.0125L44.112 14.0124L43.3893 14.7036ZM25.8824 23.7333L24.933 23.4192C24.8005 23.8197 24.9335 24.2603 25.2656 24.5205L25.8824 23.7333ZM30.6471 27.4667L31.3568 28.1712C31.5579 27.9685 31.6629 27.6895 31.6451 27.4045C31.6274 27.1195 31.4886 26.8556 31.2638 26.6795L30.6471 27.4667ZM26.9412 31.2L26.2315 30.4955C25.9661 30.7628 25.8735 31.1566 25.9918 31.5141L26.9412 31.2ZM30.2059 14.0125C29.7427 14.4967 29.3288 15.0295 28.9607 15.6076L30.6476 16.6819C30.9497 16.2076 31.2837 15.7792 31.6512 15.3949L30.2059 14.0125ZM28.9607 15.6076L27.1565 18.4402L28.8435 19.5146L30.6476 16.6819L28.9607 15.6076ZM28.8435 18.4402L27.0393 15.6076L25.3524 16.6819L27.1565 19.5146L28.8435 18.4402ZM27.0393 15.6076C26.6709 15.029 26.2573 14.4969 25.7933 14.013L24.3496 15.3972C24.717 15.7803 25.0502 16.2074 25.3524 16.6819L27.0393 15.6076ZM25.7941 14.0139C21.9526 9.99724 15.7294 9.99724 11.8879 14.0139L13.3332 15.3963C16.3872 12.2031 21.2948 12.2031 24.3488 15.3963L25.7941 14.0139ZM11.8879 14.0139C8.03739 18.0399 8.03738 24.5757 11.8878 28.6016L13.3332 27.2192C10.2223 23.9665 10.2223 18.649 13.3332 15.3963L11.8879 14.0139ZM11.8878 28.6016L27.2773 44.6912L28.7226 43.3088L13.3331 27.2192L11.8878 28.6016ZM28.7226 44.6912L44.1121 28.6002L42.6668 27.2179L27.2773 43.3088L28.7226 44.6912ZM44.1121 28.6002C47.9627 24.5742 47.9626 18.0398 44.1121 14.0125L42.6665 15.3946C45.7779 18.6489 45.7777 23.9652 42.6668 27.2179L44.1121 28.6002ZM44.112 14.0124C40.2704 9.99583 34.0474 9.99588 30.2059 14.0125L31.6512 15.3949C34.7052 12.2017 39.6127 12.2017 42.6667 15.3948L44.112 14.0124ZM27.112 18.5177C26.5831 19.5391 25.49 21.7357 24.933 23.4192L26.8317 24.0475C27.3335 22.531 28.358 20.4609 28.888 19.4372L27.112 18.5177ZM25.2656 24.5205L30.0303 28.2538L31.2638 26.6795L26.4991 22.9462L25.2656 24.5205ZM29.9373 26.7622L26.2315 30.4955L27.6509 31.9045L31.3568 28.1712L29.9373 26.7622ZM25.9918 31.5141L27.58 36.3141L29.4788 35.6859L27.8906 30.8859L25.9918 31.5141Z"
        fill="currentColor"
      />
    </svg>
  ),
  clock: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.95455C4.3834 1.95455 1.45455 4.8845 1.45455 8.5C1.45455 12.1155 4.3834 15.0455 8 15.0455C11.6142 15.0455 14.5455 12.1153 14.5455 8.5C14.5455 4.88467 11.6142 1.95455 8 1.95455ZM0 8.5C0 4.08135 3.57992 0.5 8 0.5C12.4174 0.5 16 4.08118 16 8.5C16 12.9188 12.4174 16.5 8 16.5C3.57992 16.5 0 12.9187 0 8.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68382 4.29443C8.08548 4.29443 8.41109 4.62004 8.41109 5.02171V8.18004L11.9697 11.4421C12.2658 11.7135 12.2858 12.1736 12.0144 12.4697C11.743 12.7658 11.2829 12.7858 10.9868 12.5143L7.19238 9.03608C7.0421 8.89833 6.95654 8.70383 6.95654 8.49997V5.02171C6.95654 4.62004 7.28215 4.29443 7.68382 4.29443Z"
        fill="currentColor"
      />
    </svg>
  ),
  birthday: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M3 13V18H17V13M3 13V9H10M3 13C4 13.5 5 13.5 6 13C7.5 12.25 8.5 12.25 10 13C11.5 13.75 12.5 13.75 14 13C15 12.5 16 12.5 17 13M17 13V9H10M10 9V6M10 6C8 6 8.50005 4.5 9 3.5C9.49995 2.5 10 2 10 2C10 2 10.5 2.5 11.0001 3.5C11.5001 4.5 12 6 10 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "best-clients": (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M5.721 16.4333L4.75085 16.6759L5.18378 18.4076L6.43447 17.134L5.721 16.4333ZM3 13.7111L2.27898 13.0182L1.07071 14.2755L2.76608 14.6834L3 13.7111ZM5.17102 14.2335L6.14117 13.9909L5.99418 13.403L5.40494 13.2612L5.17102 14.2335ZM14.2778 16.4333L13.5643 17.134L14.815 18.4077L15.2479 16.6759L14.2778 16.4333ZM17 13.7111L17.2338 14.6834L18.9297 14.2756L17.7209 13.0181L17 13.7111ZM14.8278 14.2335L14.594 13.2612L14.0046 13.4029L13.8576 13.9909L14.8278 14.2335ZM5.96944 10.6212L6.83239 10.116L5.96944 10.6212ZM10.0006 7.0004L11.0006 7.00056L10.0006 6.0004V7.0004ZM6.33277 8.26667C6.33277 6.24163 7.97439 4.60001 9.99944 4.60001V2.60001C6.86982 2.60001 4.33277 5.13706 4.33277 8.26667H6.33277ZM9.99944 4.60001C12.0245 4.60001 13.6661 6.24163 13.6661 8.26667H15.6661C15.6661 5.13706 13.129 2.60001 9.99944 2.60001V4.60001ZM8.50816 12.1681L5.00752 15.7327L6.43447 17.134L9.93511 13.5694L8.50816 12.1681ZM6.69114 16.1908L6.14117 13.9909L4.20088 14.476L4.75085 16.6759L6.69114 16.1908ZM5.40494 13.2612L3.23392 12.7389L2.76608 14.6834L4.93711 15.2057L5.40494 13.2612ZM10.064 13.5694L13.5643 17.134L14.9913 15.7327L11.4911 12.1681L10.064 13.5694ZM15.2479 16.6759L15.7979 14.476L13.8576 13.9909L13.3076 16.1908L15.2479 16.6759ZM15.0615 15.2057L17.2338 14.6834L16.7662 12.7388L14.594 13.2612L15.0615 15.2057ZM17.7209 13.0181L14.7505 9.92801L13.3086 11.314L16.2791 14.4041L17.7209 13.0181ZM13.6661 8.26667C13.6661 8.94301 13.4839 9.57375 13.1666 10.1158L14.8925 11.1263C15.3844 10.286 15.6661 9.30773 15.6661 8.26667H13.6661ZM13.1666 10.1158C12.5287 11.2053 11.3486 11.9333 9.99944 11.9333V13.9333C12.0876 13.9333 13.9107 12.8033 14.8925 11.1263L13.1666 10.1158ZM3.72102 14.404L6.69046 11.3142L5.24842 9.92832L2.27898 13.0182L3.72102 14.404ZM9.99944 11.9333C8.65038 11.9333 7.47025 11.2053 6.83239 10.116L5.10648 11.1265C6.08836 12.8034 7.91139 13.9333 9.99944 13.9333V11.9333ZM6.83239 10.116C6.51499 9.57387 6.33277 8.94307 6.33277 8.26667H4.33277C4.33277 9.30783 4.61448 10.2862 5.10648 11.1265L6.83239 10.116ZM11 10.5006L11.0006 7.00056L9.00056 7.00024L9 10.5002L11 10.5006ZM10.0006 6.0004H8.50056V8.0004H10.0006V6.0004Z"
        fill="currentColor"
      />
    </svg>
  ),
  diamond: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M15.2941 3H4.70588L1 7.66667L10 17L19 7.66667L15.2941 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path d="M1 7.5H18.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M8 3L6.5 7.5L10 17" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M12 3L13.5 7.5L10 17" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    </svg>
  ),
  "square-check": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="14" height="14" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
      <path d="M3 6.2666H17" stroke="currentColor" strokeWidth="2" />
      <path
        d="M5.7998 11.2203L8.85435 13.7331L14.1998 9.06641"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  cashier: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 5.5V3H4V8M13 5.5H16V11.5H13M13 5.5V8M13 11.5V14H11.5M13 11.5V11M5.5 14H4V11M5.5 14V17L7 16L8.5 17L10 16L11.5 17V14M5.5 14H7M11.5 14H10M4 11H13M4 11V8M13 11V8M4 8H7M13 8H10M7 8V14M7 8H10M7 14H10M10 8V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "kiko-me": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <g>
        <g>
          <path d="M52,23.17c-0.07-0.84-0.14-1-0.32-0.98c-0.15,0.02-0.12,0.34-0.12,0.34s0.37,4.04-3.12,7.28    c-3.49,3.23-6.38,3.66-7.44,3.18c-1.05-0.48-0.1-1.87-0.1-1.87c3.6,0.59,7.93-4.51,4.37-4.86c-3.03-0.29-5.39,3.55-5.39,3.55    c-2.6,0.66-5.43,2.71-5.75,2.67c-0.26-0.03,0.05-0.37,0.16-0.52s0.94-1.25,0.94-1.25s0.77-1.07-0.09-1.71    c-0.58-0.44-1.35,0.06-1.35,0.06s-3.56,2.23-4.69,2.88c-1.13,0.65-1.13,0.68-1.22,0.62c-0.09-0.06,0.09-0.24,0.09-0.24l1.25-1.53    c0,0,1.45-1.78,1.6-3c0.14-1.54-1.75-0.77-1.75-0.77c-3.71,1.32-12,6.01-12,6.01s-0.52,0.34-0.68,0.21    c-0.12-0.11,0.03-0.28,0.03-0.28c2.27-3.25,7.39-8.23,9.23-10c2.14-2.07,1.42-3.09,1.42-3.09s-0.96-2.45-9.22,0    C9.6,22.27,5.33,28.3,5.33,28.3s-2.62,3.56-0.52,5.55c1.55,1.47,3.84,0.65,3.84,0.65c0.18-0.07,0.17-0.16,0.14-0.24    c-0.05-0.13-0.43-0.05-0.43-0.05c-2.46,0.49-3.3-0.9-3.3-0.9c-1.26-1.87,1.19-4.43,1.19-4.43c5.57-6.32,15.57-8.34,16.29-8.47    c0.71-0.12,2.18-0.29,2.89-0.07c0.71,0.22-0.44,1.08-0.44,1.08c-4.2,3.43-7.15,7.03-7.15,7.03s-2.67,3.22-2.77,4.72    C14.94,34.8,17,33.85,17,33.85s8.75-4.3,10.09-5.01c1.95-1.03,0.94,0.11,0.77,0.4c-0.15,0.23-1.09,1.6-1.09,1.6    s-1.39,1.96-0.8,2.83c0.45,0.65,1.15,0.39,1.49,0.27c0.84-0.3,4.51-2.85,5.01-3.22c0.46-0.34,0.56-0.1,0.44,0.11    c-0.08,0.16-0.22,0.44-0.38,0.8c-0.25,0.57-0.44,0.89-0.35,1.36c0.41,1.2,1.82,0.53,1.82,0.53c3.94-1.99,5.26-2.34,5.26-2.34    c-1.65,4.17,3.08,3.09,3.08,3.09C51.78,31.55,52.08,24.27,52,23.17z M45.6,27.55c0.9,0.48-2.58,3.03-4.03,2.51    C41.48,30.03,44.44,26.93,45.6,27.55z" />
          <g>
            <polygon points="34.74,25.3 32.31,22.26 34.41,19.93 33.06,19.93 31.01,22.27 31.01,19.93 29.9,19.93 29.9,25.3      31.01,25.3 31.01,23.69 31.6,23.04 33.39,25.3    " />
            <g>
              <rect x="35.55" y="19.93" width="1.12" height="5.37" />
            </g>
            <polygon points="42.83,25.3 40.4,22.26 42.5,19.93 41.15,19.93 39.11,22.27 39.11,19.93 37.99,19.93 37.99,25.3      39.11,25.3 39.11,23.69 39.7,23.04 41.48,25.3    " />
            <path d="M44.19,25.05c-0.44-0.24-0.78-0.57-1.02-0.99s-0.36-0.9-0.36-1.44c0-0.54,0.12-1.02,0.36-1.44     c0.24-0.42,0.58-0.75,1.02-0.99c0.44-0.24,0.94-0.36,1.51-0.36c0.57,0,1.07,0.12,1.51,0.36c0.44,0.24,0.78,0.57,1.02,0.99     c0.25,0.42,0.37,0.9,0.37,1.44c0,0.54-0.12,1.02-0.37,1.44c-0.25,0.42-0.59,0.75-1.02,0.99c-0.44,0.24-0.94,0.36-1.51,0.36     C45.13,25.41,44.62,25.29,44.19,25.05z M46.61,24.16c0.27-0.15,0.47-0.36,0.63-0.63c0.15-0.27,0.23-0.57,0.23-0.92     s-0.07-0.65-0.23-0.92c-0.15-0.27-0.36-0.48-0.63-0.63c-0.27-0.15-0.57-0.23-0.91-0.23c-0.34,0-0.64,0.07-0.91,0.23     c-0.27,0.15-0.47,0.36-0.63,0.63c-0.15,0.27-0.23,0.57-0.23,0.92s0.07,0.65,0.23,0.92c0.15,0.27,0.36,0.48,0.63,0.63     c0.27,0.15,0.57,0.23,0.91,0.23C46.04,24.39,46.34,24.31,46.61,24.16z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  "loyalty-gift": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M21.93,17.8H5.31c-0.45,0-0.81,0.36-0.81,0.81v9.72c0,0.45,0.36,0.81,0.81,0.81h1.63v20.39  c0,0.45,0.36,0.81,0.81,0.81h40.51c0.45,0,0.81-0.36,0.81-0.81V29.15h1.62c0.45,0,0.81-0.36,0.81-0.81v-9.72  c0-0.45-0.36-0.81-0.81-0.81H34.07c1.59-0.63,3.18-1.48,4.29-2.59c2.06-2.06,2.72-3.88,2.59-5.38c-0.09-1.08-0.59-2.01-1.37-2.8  c-0.78-0.78-1.72-1.28-2.8-1.37c-1.5-0.13-3.32,0.53-5.38,2.59c-1.68,1.68-2.76,4.45-3.4,6.68c-0.64-2.23-1.72-5-3.4-6.68  c-2.06-2.06-3.88-2.72-5.38-2.59c-1.08,0.09-2.02,0.59-2.8,1.37c-0.78,0.78-1.28,1.72-1.37,2.8c-0.13,1.5,0.53,3.33,2.59,5.38  C18.75,16.32,20.34,17.17,21.93,17.8L21.93,17.8z M22.32,29.15v19.58H8.56V29.15L22.32,29.15z M33.67,29.15h13.78v19.58H33.67  L33.67,29.15z M32.04,29.15V48.6h-8.1V29.15L32.04,29.15z M33.67,19.42h16.21v8.1H33.67L33.67,19.42z M22.32,19.42v8.1H6.12v-8.1  H22.32z M23.94,27.53h8.1v-8.1h-8.1V27.53z M17.57,8.18c0.5-0.5,1.1-0.84,1.79-0.9c1.16-0.1,2.51,0.53,4.09,2.12  c2.15,2.15,3.17,6.25,3.55,8.22c-1.97-0.38-6.07-1.41-8.22-3.55c-1.59-1.59-2.22-2.94-2.12-4.09C16.73,9.28,17.07,8.68,17.57,8.18  L17.57,8.18z M38.43,8.18c0.5,0.5,0.84,1.1,0.9,1.79c0.1,1.16-0.53,2.51-2.12,4.09c-2.15,2.15-6.25,3.17-8.22,3.55  c0.38-1.96,1.4-6.07,3.55-8.22c1.59-1.59,2.94-2.22,4.09-2.12C37.33,7.34,37.93,7.68,38.43,8.18L38.43,8.18z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  "fast-delivery": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <g>
        <path
          fill="currentColor"
          d="M38.571,22.263c-0.315-0.317-0.792-0.317-1.107,0l-4.435,4.434c-0.715-0.475-1.426-0.713-2.297-0.713    c-1.109,0-2.139,0.475-2.93,1.267c-0.793,0.792-1.266,1.822-1.266,2.93s0.473,2.137,1.266,2.93c0.791,0.792,1.82,1.268,2.93,1.268    c1.107,0,2.137-0.476,2.93-1.268c0.791-0.793,1.267-1.821,1.267-2.93c0-0.871-0.238-1.743-0.792-2.376l4.355-4.354    C38.886,23.055,38.886,22.58,38.571,22.263L38.571,22.263z M32.632,32.001c-0.95,0.95-2.691,0.95-3.72,0    c-0.475-0.475-0.794-1.187-0.794-1.82c0-0.714,0.239-1.347,0.794-1.823c0.95-0.95,2.691-0.95,3.72,0    c0.477,0.476,0.792,1.188,0.792,1.823C33.345,30.894,33.108,31.526,32.632,32.001z"
        />
        <path
          fill="currentColor"
          d="M8.324,29.468c0,0.474,0.317,0.792,0.793,0.792h13.697c0.473,0,0.792-0.316,0.792-0.792    c0-0.475-0.318-0.792-0.792-0.792H9.117C8.642,28.676,8.324,28.991,8.324,29.468L8.324,29.468z"
        />
        <path
          fill="currentColor"
          d="M5.792,23.608h13.695c0.476,0,0.793-0.316,0.793-0.793c0-0.475-0.316-0.792-0.793-0.792L5.792,22.025    c-0.475,0-0.793,0.315-0.793,0.792C5,23.292,5.316,23.608,5.792,23.608L5.792,23.608z"
        />
        <path
          fill="currentColor"
          d="M20.281,36.119c0-0.475-0.317-0.792-0.793-0.792H5.79c-0.474,0-0.792,0.317-0.792,0.792    s0.317,0.792,0.792,0.792h13.697C19.963,36.91,20.281,36.594,20.281,36.119z"
        />
        <path
          fill="currentColor"
          d="M45.302,15.928l0.792-0.792c0.396,0.237,0.792,0.315,1.268,0.315c1.504,0,2.691-1.188,2.691-2.691    s-1.11-2.692-2.612-2.692c-1.505,0-2.693,1.188-2.693,2.692c0,0.396,0.079,0.871,0.317,1.188l-0.872,0.871    c-3.325-2.93-7.601-4.751-12.352-4.91V6.586h2.852c0.475,0,0.792-0.317,0.792-0.792s-0.315-0.792-0.792-0.792h-7.206    c-0.476,0-0.792,0.316-0.792,0.792c0,0.475,0.315,0.792,0.792,0.792h2.77v3.325c-5.225,0.238-10.055,2.375-13.697,6.255    c-0.317,0.317-0.317,0.793,0,1.108c0.316,0.317,0.792,0.317,1.108,0c3.563-3.721,8.314-5.78,13.379-5.78    c4.831,0,9.265,1.901,12.59,4.989c3.562,3.325,5.778,8.076,5.778,13.3c0,10.137-8.234,18.371-18.37,18.371    c-4.908,0-9.5-1.9-12.984-5.384c-0.316-0.316-0.792-0.316-1.108,0s-0.316,0.792,0,1.108c3.8,3.8,8.789,5.859,14.093,5.859    c11.007-0.001,19.952-8.947,19.952-19.955c0-5.383-2.139-10.292-5.7-13.856H45.302z M47.44,11.653    c0.632,0,1.107,0.475,1.107,1.108c0,0.633-0.476,1.108-1.107,1.108c-0.239,0-0.476-0.079-0.715-0.237    c0-0.08-0.079-0.08-0.079-0.158c0,0-0.079-0.08-0.157-0.08C46.33,13.236,46.33,13,46.33,12.762    C46.331,12.128,46.805,11.653,47.44,11.653L47.44,11.653z"
        />
        <path
          fill="currentColor"
          d="M21.467,42.452c-0.236,0.396-0.158,0.872,0.238,1.109c2.774,1.9,6.019,2.93,9.423,2.93    c9.185,0,16.627-7.442,16.627-16.627c0-9.184-7.442-16.628-16.627-16.628c-3.484,0-6.888,1.109-9.739,3.169    c-0.315,0.237-0.395,0.792-0.157,1.107c0.237,0.316,0.713,0.396,1.108,0.159c2.533-1.901,5.621-2.851,8.789-2.851    c8.315,0,15.044,6.729,15.044,15.043c0,8.313-6.728,15.043-15.044,15.043c-3.088,0-6.017-0.87-8.472-2.611    C22.18,42.057,21.704,42.136,21.467,42.452L21.467,42.452z"
        />
      </g>
    </svg>
  ),
  "sorting-glass": (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <image href={sortingGlass.src} width={"100%"} height={"100%"} />
    </svg>
  ),
  "sorting-container": (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <image href={sortingContainer.src} width={"100%"} height={"100%"} />
    </svg>
  ),
  discount: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
      <path
        d="M7.39941 11.1996L12.9994 5.59961"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.19941" cy="5.60078" r="0.8" stroke="currentColor" strokeWidth="2" />
      <circle cx="12.5998" cy="10.3996" r="0.8" stroke="currentColor" strokeWidth="2" />
      <path
        d="M16.1998 3.40039V12.6004C16.1998 13.1527 15.7521 13.6004 15.1998 13.6004H5.58013C5.22127 13.6004 4.88993 13.4081 4.71188 13.0965L2.08331 8.49653C1.90764 8.1891 1.90764 7.81169 2.08331 7.50425L4.71188 2.90425C4.88993 2.59268 5.22127 2.40039 5.58013 2.40039H15.1998C15.7521 2.40039 16.1998 2.8481 16.1998 3.40039Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  ),
};

export default iconList;
